import React, { useState, useEffect, useMemo, useRef } from 'react';
import { setPropertyTimezone } from './utils/dateUtils';
import { FO_MENU_KEYS } from './utils/frontOfficeMenus';
import { ModuleIcon } from './components/ModuleIcons';
import StoresModule from './screens/StoresModule';
import Login from './screens/Login';
import Dashboard from './screens/Dashboard';
import Inventory from './screens/Inventory';
import Orders from './screens/Orders';
import ItemMaster from './screens/ItemMaster';
import MenuSetup from './screens/MenuSetup';
import LiquorCategory from './screens/LiquorCategory';
import GstMaster from './screens/GstMaster';
import RoomTaxPolicyMaster from './screens/RoomTaxPolicyMaster';
import Users from './screens/Users';
import TableMaster from './screens/TableMaster';
import ChainMaster from './screens/ChainMaster';
import PropertyMaster from './screens/PropertyMaster';
import KOTModule from './screens/KOTModule';
import CountryMaster from './screens/CountryMaster';
import CurrencyMaster from './screens/CurrencyMaster';
import TimezoneMaster from './screens/TimezoneMaster';
import KotMenuTypeMaster from './screens/KotMenuTypeMaster';
import KotMenuCategoryMaster from './screens/KotMenuCategoryMaster';
import KotFoodTypeMaster from './screens/KotFoodTypeMaster';
import KotFoodCategoryMaster from './screens/KotFoodCategoryMaster';
import KotItemMaster from './screens/KotItemMaster';
import KotTimeSlotMaster from './screens/KotTimeSlotMaster';
import KotTaxProfileMaster from './screens/KotTaxProfileMaster';
import KotPricingProfileMaster from './screens/KotPricingProfileMaster';
import KotTableMaster from './screens/KotTableMaster';
import KotOutletMaster from './screens/KotOutletMaster';
import KotKitchenStationMaster from './screens/KotKitchenStationMaster';
import KitchenPunchBoard from './screens/KitchenPunchBoard';
import BarStationDisplay from './screens/BarStationDisplay';
import KotMastersHub from './screens/KotMastersHub';
import UomMaster from './screens/UomMaster';
import StoreMaster from './screens/StoreMaster';
import FoodItemMaster from './screens/FoodItemMaster';
import FoodSupplierMaster from './screens/FoodSupplierMaster';
import FoodGeneralSettings from './screens/FoodGeneralSettings';
import GeneralSettings from './screens/GeneralSettings';
import FoodPurchaseRequisition from './screens/FoodPurchaseRequisition';
import FoodStoreMaster from './screens/FoodStoreMaster';
import FoodPurchaseOrder from './screens/FoodPurchaseOrder';
import FoodGrn from './screens/FoodGrn';
import FoodStockView from './screens/FoodStockView';
import FoodStoreIssue from './screens/FoodStoreIssue';
import FoodStockTransfer from './screens/FoodStockTransfer';
import FoodStockAdjustment from './screens/FoodStockAdjustment';
import FoodPhysicalCount from './screens/FoodPhysicalCount';
import FoodReports from './screens/FoodReports';
import KotBillReports from './screens/KotBillReports';
import KotDashboard from './screens/KotDashboard';
import AdminAuditTrails from './screens/AdminAuditTrails';
import PmsUserLoginActivity from './screens/PmsUserLoginActivity';
import AdminErrorLog from './screens/AdminErrorLog';
import CommandPalette from './components/CommandPalette';
import PmsReports from './screens/PmsReports';
import BarReports from './screens/BarReports';
import BarBillingInfo from './screens/BarBillingInfo';
import BarMastersHub from './screens/BarMastersHub';
import AccountingTallyExport from './screens/AccountingTallyExport';
import AccountingReconciliation from './screens/AccountingReconciliation';
import AccountingExportSettings from './screens/AccountingExportSettings';
import TallyPushSettings from './screens/TallyPushSettings';
import TallyLivePush from './screens/TallyLivePush';
import PmsExpenseDashboard from './screens/PmsExpenseDashboard';
import PmsExpenseEntry from './screens/PmsExpenseEntry';
import PmsExpenseList from './screens/PmsExpenseList';
import PmsExpenseApproval from './screens/PmsExpenseApproval';
import PmsPettyCash from './screens/PmsPettyCash';
import PmsExpenseMastersHub from './screens/PmsExpenseMastersHub';
import PmsRevenueTargetDashboard from './screens/PmsRevenueTargetDashboard';
import PmsRevenueReports from './screens/PmsRevenueReports';
import PmsExpenseReports from './screens/PmsExpenseReports';
import PmsExpenseAnomaly from './screens/PmsExpenseAnomaly';
import PmsPropertyPnl from './screens/PmsPropertyPnl';
import FaqAssistant from './screens/FaqAssistant';
import ChannelManagerSettings from './screens/ChannelManagerSettings';
import ChangePasswordModal from './screens/ChangePasswordModal';
import CompetitorRateSettings from './screens/CompetitorRateSettings';
import RateShopperLog from './screens/RateShopperLog';
import TrainingMaterial from './screens/TrainingMaterial';
import PmsLockAgents from './screens/PmsLockAgents';
import PmsLockVendorConfig from './screens/PmsLockVendorConfig';
import PmsLockAuthorizations from './screens/PmsLockAuthorizations';
import PmsDoorAudit from './screens/PmsDoorAudit';
import SmsProviderSettings from './screens/SmsProviderSettings';
import SmsTemplatesEvents from './screens/SmsTemplatesEvents';
import WhatsAppPlatformSettings from './screens/WhatsAppPlatformSettings';
import WhatsAppHotelSettings from './screens/WhatsAppHotelSettings';
import BanquetQuotation from './screens/BanquetQuotation';
import BanquetMenuMaster from './screens/BanquetMenuMaster';
import BanquetQuotationV2 from './screens/BanquetQuotationV2';
import BanquetBooking from './screens/BanquetBooking';
import BanquetPayments from './screens/BanquetPayments';
import BanquetCalendar from './screens/BanquetCalendar';
import BanquetReports from './screens/BanquetReports';
import BanquetCompetitorMaster from './screens/BanquetCompetitorMaster';
import GoogleReview from './screens/GoogleReview';
import PmsAlertSettings from './screens/PmsAlertSettings';
import HkConfigHub from './screens/HkConfigHub';
import HkAmenityStock from './screens/HkAmenityStock';
import PmsUpsellProducts from './screens/PmsUpsellProducts';
import PmsUpsellLeaderboard from './screens/PmsUpsellLeaderboard';
import BanquetDemandForecast from './screens/BanquetDemandForecast';
import BanquetPricingAdvisor from './screens/BanquetPricingAdvisor';
import BanquetVarianceReport from './screens/BanquetVarianceReport';
import BanquetIntelConfig from './screens/BanquetIntelConfig';
import EventApiConfig from './screens/EventApiConfig';
import EventSyncLog from './screens/EventSyncLog';
import BanquetMastersHub from './screens/BanquetMastersHub';
import BanquetCrmDashboard from './screens/BanquetCrmDashboard';
import PmsBanquetLeadConflicts from './screens/PmsBanquetLeadConflicts';
import BanquetLeads from './screens/BanquetLeads';
import BanquetLeadDetail from './screens/BanquetLeadDetail';
import BanquetPipeline from './screens/BanquetPipeline';
import BanquetFollowUps from './screens/BanquetFollowUps';
import BanquetCrmConfig from './screens/BanquetCrmConfig';
import RoleTemplateMaster from './screens/RoleTemplateMaster';
import PmsCommandCenter from './screens/PmsCommandCenter';
import PmsFrontDeskBoard from './screens/PmsFrontDeskBoard';
import PmsMastersHub from './screens/PmsMastersHub';
import PmsPolicyConfig from './screens/PmsPolicyConfig';
import PmsReservation from './screens/PmsReservation';
import PmsRateMatrix from './screens/PmsRateMatrix';
import PmsRateMatrixUpdate from './screens/PmsRateMatrixUpdate';
import PmsWalkInCheckIn from './screens/PmsWalkInCheckIn';
import PmsHousekeeping from './screens/PmsHousekeeping';
import MaintDashboard from './screens/MaintDashboard';
import MaintWorkOrders from './screens/MaintWorkOrders';
import MaintPreventive from './screens/MaintPreventive';
import MaintMastersHub from './screens/MaintMastersHub';
import MaintReports from './screens/MaintReports';
import PmsGuestRequests from './screens/PmsGuestRequests';
import PmsGuestPortalConfig from './screens/PmsGuestPortalConfig';
import PmsPreCheckinConfig from './screens/PmsPreCheckinConfig';
import PmsGuestLoginAudit from './screens/PmsGuestLoginAudit';
import PmsGuestFeedback from './screens/PmsGuestFeedback';
import PmsNlpConfig from './screens/PmsNlpConfig';
import PmsGuestMaster from './screens/PmsGuestMaster';
import PmsDashboard from './screens/PmsDashboard';
import PmsCompliancePolicy from './screens/PmsCompliancePolicy';
import PmsPoliceReport from './screens/PmsPoliceReport';
import PmsInvoiceRegister from './screens/PmsInvoiceRegister';
import PmsRateQuotation from './screens/PmsRateQuotation';
import PmsFolioVoidAudit from './screens/PmsFolioVoidAudit';
import PmsInvoiceAmendmentAudit from './screens/PmsInvoiceAmendmentAudit';
import PmsAgentPayments from './screens/PmsAgentPayments';
import PmsCmMapping from './screens/PmsCmMapping';
import PmsCmBookingLog from './screens/PmsCmBookingLog';
import PmsCmPushLog from './screens/PmsCmPushLog';
import PmsCmRatePushLog from './screens/PmsCmRatePushLog';
import PmsCmBookingPushLog from './screens/PmsCmBookingPushLog';
import PmsRoomInventory from './screens/PmsRoomInventory';
import PmsGroupBooking from './screens/PmsGroupBooking';
import PmsNightAudit from './screens/PmsNightAudit';
import PmsGmReports from './screens/PmsGmReports';
import PmsAiFeatureConfig from './screens/PmsAiFeatureConfig';
import PmsRevenueManager from './screens/PmsRevenueManager';
import RateShopperMapping from './screens/RateShopperMapping';
import RateShopper from './screens/RateShopper';
import PriceIntelligence from './screens/PriceIntelligence';
import PickupPace from './screens/PickupPace';
import RateShopperReports from './screens/RateShopperReports';
import RevenueManagerRms from './screens/RevenueManagerRms';
import PmsNoShowPredictor from './screens/PmsNoShowPredictor';
import PmsGuestRecognition from './screens/PmsGuestRecognition';
import PmsHotelAiFeatures from './screens/PmsHotelAiFeatures';
import PmsOccupancyForecast from './screens/PmsOccupancyForecast';
import PmsUpsellEngine from './screens/PmsUpsellEngine';
import PmsStaffAssistant from './screens/PmsStaffAssistant';
import AiFloatingWidget from './screens/AiFloatingWidget';
import ReportIssueWidget from './screens/ReportIssueWidget';
import AiAssistantWidget from './screens/AiAssistantWidget';
import TicketingSettings from './screens/TicketingSettings';
import PmsFolioAnomaly from './screens/PmsFolioAnomaly';
import PmsNightAuditAnomaly from './screens/PmsNightAuditAnomaly';
import PmsCorporateCreditRisk from './screens/PmsCorporateCreditRisk';
import PmsThemeSettings from './screens/PmsThemeSettings';
import ShortenUrlSettings from './screens/ShortenUrlSettings';
import AiUsageDashboard from './screens/AiUsageDashboard';
import SubscriptionModuleCatalog from './screens/SubscriptionModuleCatalog';
import SubscriptionPlanManager from './screens/SubscriptionPlanManager';
import SubscriptionList from './screens/SubscriptionList';
import SubscriptionDetail from './screens/SubscriptionDetail';
import SubscriptionPriceOverrides from './screens/SubscriptionPriceOverrides';
import SubscriptionConfig from './screens/SubscriptionConfig';
import SubscriptionDashboard from './screens/SubscriptionDashboard';
import MySubscription from './screens/MySubscription';
import MySubscriptionInvoices from './screens/MySubscriptionInvoices';
import GstReports from './screens/GstReports';
import GstConfig from './screens/GstConfig';
import PmsGoLivePurge from './screens/PmsGoLivePurge';
import useTheme, { resetTheme } from './hooks/useTheme';
import useIsMobile from './hooks/useIsMobile';
import useOnlineStatus from './hooks/useOnlineStatus';

// Global safety: detect and remove orphaned overlay backdrops that block the page
// Also: triple-press Escape to force-clear all overlays (emergency escape hatch)
function useOverlayGuard() {
  React.useEffect(() => {
    // Escape key emergency: triple-press Escape within 2 seconds clears all overlays
    let escCount = 0;
    let escTimer = null;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        escCount++;
        if (escCount >= 3) {
          escCount = 0;
          console.warn('[OverlayGuard] Emergency: clearing all fixed overlays');
          document.querySelectorAll('div').forEach(el => {
            const s = window.getComputedStyle(el);
            if (s.position === 'fixed' && parseInt(s.zIndex) > 100 && el.offsetWidth >= window.innerWidth * 0.8) {
              el.style.display = 'none';
              el.style.pointerEvents = 'none';
            }
          });
        }
        clearTimeout(escTimer);
        escTimer = setTimeout(() => { escCount = 0; }, 2000);
      }
    };
    document.addEventListener('keydown', handleKeyDown);

    let guardInterval;
    const checkForOrphanedOverlays = () => {
      // Find any fixed-position element that covers the full viewport and blocks pointer events
      document.querySelectorAll('div').forEach(el => {
        const s = window.getComputedStyle(el);
        if (
          s.position === 'fixed' &&
          el.offsetWidth >= window.innerWidth * 0.9 &&
          el.offsetHeight >= window.innerHeight * 0.9 &&
          s.pointerEvents !== 'none' &&
          parseFloat(s.opacity) > 0 &&
          parseInt(s.zIndex) > 100
        ) {
          // Check if this overlay has NO visible child content (orphaned backdrop)
          const hasVisibleChild = Array.from(el.children).some(child => {
            const cs = window.getComputedStyle(child);
            return child.offsetWidth > 50 && child.offsetHeight > 50 && parseFloat(cs.opacity) > 0 && cs.display !== 'none';
          });
          if (!hasVisibleChild) {
            console.warn('[OverlayGuard] Removing orphaned backdrop:', el.className || el.tagName);
            el.style.display = 'none';
            el.style.pointerEvents = 'none';
            el.style.opacity = '0';
          }
        }
      });
    };
    // Check every 5 seconds
    guardInterval = setInterval(checkForOrphanedOverlays, 5000);
    return () => { clearInterval(guardInterval); document.removeEventListener('keydown', handleKeyDown); };
  }, []);
}

function App() {
  useOverlayGuard();

  const decodeJwtPayload = (jwtToken) => {
    try {
      const payload = String(jwtToken || '').split('.')[1];
      if (!payload) return {};
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
      const decoded = atob(padded);
      return JSON.parse(decoded);
    } catch (_) {
      return {};
    }
  };

  const [token, setToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(localStorage.getItem('refreshToken') || '');
  const [role, setRole] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [userScopes, setUserScopes] = useState(() => {
    try {
      const raw = localStorage.getItem('userScopes');
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  });
  const [username, setUsername] = useState(localStorage.getItem('username') || '');
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [supportMenuOpen, setSupportMenuOpen] = useState(false);
  const [cmdOpen, setCmdOpen] = useState(false);
  const [recentScreens, setRecentScreens] = useState(() => {
    try { return JSON.parse(localStorage.getItem('easepms_recent_screens') || '[]'); } catch { return []; }
  });
  const [stats, setStats] = useState({ totalOrders: 0, todayOrdersCount: 0, todayOrderAmount: 0, lowStock: [] });

  const [activeMenu, setActiveMenu] = useState('hotel-config');
  const [screen, setScreen] = useState('property-selector');
  const [cmTab, setCmTab] = useState('mapping');
  const [barSection, setBarSection] = useState('operations');
  const [foodSection, setFoodSection] = useState('operations');
  const [accessibleProperties, setAccessibleProperties] = useState([]);
  // Unfiltered mirror of the same fetch (accessibleProperties itself stays
  // active-only — it drives selection/auto-select logic elsewhere) — used
  // only to render an "Inactive" group on the property-selector screen.
  const [allPropertiesRaw, setAllPropertiesRaw] = useState([]);
  const [propertyQuickStats, setPropertyQuickStats] = useState({});
  const [selectedPropertyId, setSelectedPropertyId] = useState(localStorage.getItem('selectedPropertyId') || '');
  // Transient "Copied" feedback for the property-UUID copy buttons (property id).
  const [copiedPropId, setCopiedPropId] = useState('');
  const [propertySearchQuery, setPropertySearchQuery] = useState('');
  const copyPropertyId = (id) => {
    const val = String(id || '');
    const done = () => { setCopiedPropId(val); setTimeout(() => setCopiedPropId(''), 1500); };
    try {
      if (navigator.clipboard?.writeText) { navigator.clipboard.writeText(val).then(done).catch(done); }
      else { const ta = document.createElement('textarea'); ta.value = val; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); done(); }
    } catch (_) { done(); }
  };
  // Portal segregation (UI-only): 'console' = Platform Console (admin), 'workspace'
  // = Hotel Workspace (hotel user, or admin who has entered a property). Only
  // role==='admin' can be in 'console'; everyone else is locked to 'workspace'.
  // This governs navigation visibility ONLY — it is not a security boundary
  // (routes stay server-guarded). See docs/DESIGN_PLATFORM_CONSOLE_HOTEL_WORKSPACE.md
  const [portalMode, setPortalMode] = useState(localStorage.getItem('easepms_portal_mode') || 'console');
  const [kotOutlets, setKotOutlets] = useState([]);
  const [selectedKotOutletId, setSelectedKotOutletId] = useState('');
  const [moduleAccessError, setModuleAccessError] = useState('');
  // Clear module access error whenever screen changes
  useEffect(() => { setModuleAccessError(''); }, [screen]);
  // Persist portal mode; lock non-admins to the Hotel Workspace (they can never
  // reach the Platform Console).
  useEffect(() => { localStorage.setItem('easepms_portal_mode', portalMode); }, [portalMode]);
  useEffect(() => {
    if (role && role !== 'admin' && portalMode !== 'workspace') setPortalMode('workspace');
  }, [role, portalMode]);
  const [pmsWalkInPrefill, setPmsWalkInPrefill] = useState(null);
  const [openEditReservationId, setOpenEditReservationId] = useState(null);
  const [pendingKotBillId, setPendingKotBillId] = useState(null);
  const [pendingBarOrderId, setPendingBarOrderId] = useState(null);
  const [banquetCrmLeadId, setBanquetCrmLeadId] = useState(null);
  // Cluster_key the leads list passes when the user clicks the
  // "AI RECOMMENDED" / "IN CONFLICT" badge — the Conflicts screen scrolls
  // to and highlights that specific cluster card on mount.
  const [banquetFocusClusterKey, setBanquetFocusClusterKey] = useState(null);
  // Deep-link from Rate Shopper/Price Intelligence into a specific RMS decision —
  // same lifted-state pattern as banquetFocusClusterKey above.
  const [rmsFocus, setRmsFocus] = useState(null);
  // Deep-link from Price Intelligence's recommendation drawer into Rate Shopper's
  // RS-04 date-detail drawer (the competitor evidence behind a recommendation).
  const [rateShopperFocus, setRateShopperFocus] = useState(null);
  const [banquetLeadPrefill, setBanquetLeadPrefill] = useState(null);
  const [prefillGuestForWalkIn, setPrefillGuestForWalkIn] = useState(null);
  const [prefillGuestForReservation, setPrefillGuestForReservation] = useState(null);
  const authPopupActiveRef = useRef(false);
  const [requestBadgeCounts, setRequestBadgeCounts] = useState({ hkOpen: 0, svcOpen: 0 });
  const [aiFeatures, setAiFeatures] = useState({});
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
  const hoverTimeoutRef = useRef(null);
  const navScrollRef = useRef(null);
  const [navCanScrollLeft, setNavCanScrollLeft] = useState(false);
  const [navCanScrollRight, setNavCanScrollRight] = useState(false);

  const updateNavScrollButtons = () => {
    const el = navScrollRef.current;
    if (!el) return;
    setNavCanScrollLeft(el.scrollLeft > 0);
    setNavCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  useEffect(() => {
    const el = navScrollRef.current;
    if (!el) return;
    updateNavScrollButtons();
    const ro = new ResizeObserver(updateNavScrollButtons);
    ro.observe(el);
    el.addEventListener('scroll', updateNavScrollButtons);
    return () => { ro.disconnect(); el.removeEventListener('scroll', updateNavScrollButtons); };
  }, [token, permissions, role]);
  const [feedbackCount, setFeedbackCount] = useState(0);
  const [guestRequestCount, setGuestRequestCount] = useState(0);
  const [ticketingEnabled, setTicketingEnabled] = useState(false);
  const [propertyClock, setPropertyClock] = useState('');
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [fabOpen, setFabOpen] = useState(false);
  const [fabHover, setFabHover] = useState(false);
  const [mobileExpandedMenu, setMobileExpandedMenu] = useState(null);
  // Phase 3: opt-in collapsible left rail (default off). Persisted per browser.
  const [navMode, setNavMode] = useState(() => {
    try { return localStorage.getItem('easepms_nav_mode') === 'sidebar' ? 'sidebar' : 'topbar'; } catch { return 'topbar'; }
  });
  const [railFlyout, setRailFlyout] = useState(null);
  const [railFlyoutTop, setRailFlyoutTop] = useState(56);
  // Anchor the rail flyout to the icon the user actually clicked/hovered, so the
  // panel opens beside it instead of jumping to a fixed top (which forced a long
  // diagonal mouse travel that tripped the auto-close before it could be clicked).
  const anchorRailFlyout = (e) => {
    try {
      const t = e.currentTarget.getBoundingClientRect().top;
      const vh = typeof window !== 'undefined' ? window.innerHeight : 800;
      setRailFlyoutTop(Math.max(56, Math.min(t, vh - 260)));
    } catch { setRailFlyoutTop(56); }
  };
  const railTimerRef = useRef(null);
  const { isMobile, isTablet } = useIsMobile();
  const { isOnline } = useOnlineStatus();

  // Module visibility comes from each module's can_X flag. The "Hotel Admin"
  // checkbox (permissions.hotel_admin) only controls admin-action capabilities
  // (user master, configs, etc.) inside whichever modules the user can see —
  // it does NOT cross-grant module access. system-wide role === 'admin' still
  // passes every gate.
  const hasPermission = key => role === 'admin' || Boolean(permissions?.[key]);
  const hasBarPermission = role === 'admin' || Boolean(permissions?.bar ?? permissions?.inventory);
  const hasKotPermission = role === 'admin' || Boolean(permissions?.kot ?? permissions?.orders);
  const hasFoodKitchenAccess = role === 'admin' || Boolean(permissions?.food_admin) || Boolean(permissions?.food_kitchen_staff);
  const hasFoodStoreReceiveAccess = role === 'admin' || Boolean(permissions?.food_admin) || Boolean(permissions?.food_store_receive);
  const hasFoodStoreIssueAccess = role === 'admin' || Boolean(permissions?.food_admin) || Boolean(permissions?.food_store_issue);
  const hasFoodStoreManagerAccess = role === 'admin' || Boolean(permissions?.food_admin) || Boolean(permissions?.food_store_manager);
  const hasFoodStorekeeperAccess = role === 'admin' || Boolean(permissions?.food_admin) || Boolean(permissions?.food_storekeeper);
  const hasFoodPurchaseStaffAccess = role === 'admin' || Boolean(permissions?.food_admin) || Boolean(permissions?.food_purchase_staff);
  const hasFoodPurchaseManagerAccess = role === 'admin' || Boolean(permissions?.food_admin) || Boolean(permissions?.food_purchase_manager);
  const hasFoodCostControllerAccess = role === 'admin' || Boolean(permissions?.food_admin) || Boolean(permissions?.food_cost_controller);
  const hasFoodInventoryPermission = hasKotPermission || hasFoodKitchenAccess || hasFoodStoreReceiveAccess || hasFoodStoreIssueAccess || hasFoodStoreManagerAccess || hasFoodStorekeeperAccess || hasFoodPurchaseStaffAccess || hasFoodPurchaseManagerAccess || hasFoodCostControllerAccess;
  const hasMastersAccess = role === 'admin' || hasPermission('masters');
  const hasBanquetPermission = role === 'admin' || Boolean(permissions?.banquet) || Boolean(permissions?.can_banquet);
  const hasFrontOfficePermission = role === 'admin' || Boolean(permissions?.front_office) || Boolean(permissions?.can_front_office);

  const selectedProperty = useMemo(
    () => accessibleProperties.find((p) => String(p.id) === String(selectedPropertyId)) || null,
    [accessibleProperties, selectedPropertyId]
  );
  useTheme(selectedProperty);
  // Sync property timezone to localStorage for dateUtils
  useEffect(() => {
    setPropertyTimezone(selectedProperty?.timezone || 'Asia/Kolkata');
  }, [selectedProperty?.timezone]);

  // Live property clock
  useEffect(() => {
    const tz = selectedProperty?.timezone || 'Asia/Kolkata';
    const update = () => {
      try {
        setPropertyClock(new Date().toLocaleString('en-IN', {
          timeZone: tz,
          day: '2-digit', month: 'short',
          hour: '2-digit', minute: '2-digit', hour12: true,
        }));
      } catch (_) { setPropertyClock(''); }
    };
    update();
    // No seconds shown any more, so a 1s tick just re-rendered the same
    // minute-granularity text repeatedly — 30s keeps it fresh without that.
    const interval = setInterval(update, 30000);
    return () => clearInterval(interval);
  }, [selectedProperty?.timezone]);
  const hasHousekeepingPermission = role === 'admin' || Boolean(permissions?.housekeeping) || Boolean(permissions?.can_housekeeping);
  const isBarModuleEnabledForProperty = Boolean(selectedProperty?.module_bar_enabled ?? true);
  const isKotModuleEnabledForProperty = Boolean(selectedProperty?.module_kot_pos_enabled ?? true);
  const isFoodInventoryModuleEnabledForProperty = Boolean(selectedProperty?.module_food_inventory_enabled ?? true);
  const isFrontOfficeModuleEnabledForProperty = Boolean(selectedProperty?.module_front_office_enabled ?? true);
  const isHousekeepingModuleEnabledForProperty = selectedProperty ? Boolean(selectedProperty.module_housekeeping_enabled ?? true) : true;
  const isBanquetModuleEnabledForProperty = selectedProperty ? Boolean(selectedProperty.module_banquet_enabled ?? true) : true;
  // Banquet with CRM (leads, pipeline, follow-ups, CRM config) is enabled per property
  // independently of the core Banquet module (quotations, bookings, masters...).
  const isBanquetCrmModuleEnabledForProperty = selectedProperty ? Boolean(selectedProperty.module_banquet_crm_enabled ?? true) : true;
  const isAccountingModuleEnabledForProperty = selectedProperty ? Boolean(selectedProperty.module_accounting_enabled ?? true) : true;

  // AI features: require BOTH global toggle (ai_feature_config) AND property-level module flag
  const isAiRevenueManagerActive = Boolean(aiFeatures.REVENUE_MANAGER?.is_enabled) && Boolean(selectedProperty?.module_ai_revenue_manager_enabled);
  // Rate Shopper (Pricing Intelligence Suite — base product). Gated only by the
  // per-property paid add-on flag; independent of the AI Revenue Manager toggle.
  const isRateShopperActive = Boolean(selectedProperty?.module_rate_shopper_enabled);
  // Price Intelligence requires the Rate Shopper base (SRS: PI is never sold alone).
  const isPriceIntelligenceActive = Boolean(selectedProperty?.module_price_intelligence_enabled) && isRateShopperActive;
  // Revenue Manager (RMS) requires Rate Shopper; Price Intelligence is OPTIONAL (RMS consumes PI recos if licensed).
  const isRevenueManagerRmsActive = Boolean(selectedProperty?.module_revenue_manager_enabled) && isRateShopperActive;
  const isAiGuestSentimentActive = Boolean(aiFeatures.GUEST_SENTIMENT?.is_enabled) && Boolean(selectedProperty?.module_ai_guest_sentiment_enabled);
  const isAiNoShowPredictorActive = Boolean(aiFeatures.NO_SHOW_PREDICTOR?.is_enabled) && Boolean(selectedProperty?.module_ai_noshow_predictor_enabled);
  const isAiGuestRecognitionActive = Boolean(aiFeatures.GUEST_RECOGNITION?.is_enabled) && Boolean(selectedProperty?.module_ai_guest_recognition_enabled);
  const isAiHousekeepingOptimizerActive = Boolean(aiFeatures.HOUSEKEEPING_OPTIMIZER?.is_enabled) && Boolean(selectedProperty?.module_ai_housekeeping_optimizer_enabled);
  const isAiOccupancyForecastActive = Boolean(aiFeatures.OCCUPANCY_FORECAST?.is_enabled) && Boolean(selectedProperty?.module_ai_occupancy_forecast_enabled);
  const isAiUpsellEngineActive = Boolean(aiFeatures.UPSELL_ENGINE?.is_enabled) && Boolean(selectedProperty?.module_ai_upsell_engine_enabled);
  const isAiStaffAssistantActive = Boolean(aiFeatures.STAFF_ASSISTANT?.is_enabled) && Boolean(selectedProperty?.module_ai_staff_assistant_enabled);
  const isAiFolioAnomalyActive = Boolean(aiFeatures.FOLIO_ANOMALY?.is_enabled) && Boolean(selectedProperty?.module_ai_folio_anomaly_enabled);
  const isAiCorporateCreditRiskActive = Boolean(aiFeatures.CORPORATE_CREDIT_RISK?.is_enabled) && Boolean(selectedProperty?.module_ai_corporate_risk_enabled);
  const isAiNightAuditAnomalyActive = Boolean(aiFeatures.NIGHT_AUDIT_ANOMALY?.is_enabled) && Boolean(selectedProperty?.module_ai_night_audit_anomaly_enabled);

  const hasAiFunctionsAccess = role === 'admin' || Boolean(permissions?.ai_functions);
  const hasBarAccess = hasBarPermission && isBarModuleEnabledForProperty;
  const hasKotAccess = hasKotPermission && isKotModuleEnabledForProperty;
  const hasFoodInventoryAccess = hasFoodInventoryPermission && isFoodInventoryModuleEnabledForProperty;
  const hasFrontOfficeAccess = hasFrontOfficePermission && isFrontOfficeModuleEnabledForProperty;
  // Users → Front Office Menus: a saved list limits the user to those Front
  // Office screens (e.g. sales: Reservations only). No list = every screen;
  // Admin / Hotel Admin are never limited.
  const isFoMenuUnrestricted = role === 'admin' || String(role || '').toLowerCase() === 'hotel_admin' || Boolean(permissions?.hotel_admin) || !Array.isArray(permissions?.fo_menu_access);
  const foMenuAllows = (key) => isFoMenuUnrestricted || permissions.fo_menu_access.includes(key);
  const foFirstScreen = FO_MENU_KEYS.find(foMenuAllows) || null;
  const hasHousekeepingAccess = hasHousekeepingPermission && isHousekeepingModuleEnabledForProperty;
  const hasBanquetCoreAccess = hasBanquetPermission && isBanquetModuleEnabledForProperty;
  const hasBanquetCrmAccess = hasBanquetPermission && isBanquetCrmModuleEnabledForProperty;
  // The Banquet menu is shown when either Banquet or Banquet with CRM is enabled.
  const hasBanquetAccess = hasBanquetCoreAccess || hasBanquetCrmAccess;
  const hasAccountingPermission = role === 'admin' || Boolean(permissions?.accounting);
  const hasAccountingAccess = hasAccountingPermission && isAccountingModuleEnabledForProperty;
  const hasMaintenancePermission = role === 'admin' || Boolean(permissions?.maintenance);
  // Any authenticated user can raise a maintenance request, but full module access needs the permission
  const hasMaintenanceAccess = hasMaintenancePermission;
  // Stores: only when switched on for the property (Property Master). Then
  // Admin / Hotel Admin always; other users when Stores is ticked for them
  // (Users) and a Stores role is assigned for this property — the Stores API
  // checks both, so ask it.
  const isStoresModuleEnabledForProperty = Boolean(selectedProperty?.module_stores_enabled);
  const [storesRoles, setStoresRoles] = useState([]);
  useEffect(() => {
    setStoresRoles([]);
    if (!token || !selectedProperty?.id || !selectedProperty?.module_stores_enabled || role === 'admin' || role === 'hotel_admin' || permissions?.hotel_admin) return undefined;
    let cancelled = false;
    fetch('/api/v1/stores/me', { headers: { Authorization: `Bearer ${token}`, 'x-chain-id': selectedProperty.chain_id || '', 'x-property-id': selectedProperty.id } })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => { if (!cancelled && Array.isArray(data?.roles)) setStoresRoles(data.roles); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [token, selectedProperty, role, permissions]);
  const hasStoresAccess = isStoresModuleEnabledForProperty
    && (role === 'admin' || role === 'hotel_admin' || Boolean(permissions?.hotel_admin) || storesRoles.length > 0);

  // Expense & Profitability module gates (SRS_EXPENSE_PROFITABILITY §10.2.2)
  const isExpenseModuleEnabledForProperty = selectedProperty
    ? Boolean(selectedProperty.module_expense_enabled ?? true)
    : true;
  const hasExpensePermission = role === 'admin' || Boolean(permissions?.expenses);
  const hasExpenseAccess = hasExpensePermission && isExpenseModuleEnabledForProperty;
  const hasExpenseApproveAccess = hasExpenseAccess && (role === 'admin' || Boolean(permissions?.expense_approve));
  const hasExpenseAdminAccess = hasExpenseAccess && (role === 'admin' || Boolean(permissions?.expense_admin));
  const hasPettyCashAccess = hasExpenseAccess && (role === 'admin' || Boolean(permissions?.petty_cash));
  // Revenue Target Dashboard (sub-module of Expense & Profitability).
  // SRS_REVENUE_TARGET_DASHBOARD.md §2 — permission is intentionally separate
  // from `expenses` so an owner can see top-line revenue without expense detail.
  const hasRevenueDashboardAccess = isExpenseModuleEnabledForProperty
    && (role === 'admin' || Boolean(permissions?.revenue_dashboard));
  const hasRevenueTargetAdminAccess = hasRevenueDashboardAccess
    && (role === 'admin' || Boolean(permissions?.revenue_target_admin));

  // Keep a restricted user off Front Office screens they were not given,
  // however they got there (palette, a button inside another screen, etc.).
  useEffect(() => {
    if (isFoMenuUnrestricted) return;
    const needed = screen === 'pms-rate-matrix-update' ? 'pms-rate-matrix' : screen;
    if (!FO_MENU_KEYS.includes(needed) || foMenuAllows(needed)) return;
    if (foFirstScreen) {
      setActiveMenu('front-office');
      setScreen(foFirstScreen);
    } else {
      setActiveMenu('hotel-config');
      setScreen('property-selector');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screen, isFoMenuUnrestricted, foFirstScreen]);

  const menuMap = {
    'hotel-config': [
      { key: 'property-selector', label: 'Select Property' },
      { key: 'faq-assistant', label: 'FAQ' },
      { key: 'role-templates', label: 'Role Templates', permission: 'hotel_admin' },
      { key: 'property-master', label: 'Property Master', adminOnly: true },
      { key: 'gst-master', label: 'Tax Master', permission: 'masters' },
      { key: 'room-tax-policy-master', label: 'Room Tax Policy', permission: 'masters' },
      { key: 'general-settings', label: 'General Settings', permission: 'hotel_admin' },
      { key: 'compliance-policy', label: 'Compliance', permission: 'hotel_admin' },
      { key: 'hk-config', label: 'Housekeeping', permission: 'hotel_admin' },
      { key: 'pms-policy-config', label: 'PMS Policy', permission: 'front_office' },
      { key: 'guest-portal-settings', label: 'Guest Portal', permission: 'hotel_admin' },
      { key: 'pre-checkin-config', label: 'Pre-Check-In', permission: 'hotel_admin' },
      { key: 'guest-login-audit', label: 'Guest Login Audit', permission: 'hotel_admin' },
      { key: 'hotel-ai-features', label: 'AI Features', permission: 'hotel_admin' },
      { key: 'theme-settings', label: 'Theme Settings', permission: 'hotel_admin' },
      { key: 'users', label: 'Users', permission: 'hotel_admin' },
      { key: 'my-subscription', label: 'Subscription', permission: 'hotel_admin' },
      { key: 'my-subscription-invoices', label: 'Invoices', permission: 'hotel_admin' },
      { key: 'tally-push-settings', label: 'Tally Settings', permission: 'hotel_admin' },
      { key: 'email-settings', label: 'SMS / Email Settings', permission: 'hotel_admin' },
      { key: 'alert-settings', label: 'Alert Settings', permission: 'hotel_admin' },
      { key: 'whatsapp-settings', label: 'WhatsApp', permission: 'hotel_admin' },
      { key: 'lock-system', label: 'Lock System', permission: 'lock_admin' },
      { key: 'lock-agents', label: 'Lock Agents', permission: 'lock_admin' },
      { key: 'lock-authorizations', label: 'Lock Authorisations', permission: 'lock_admin' }
    ],

    subscription: [
      { key: 'sub-dashboard', label: 'Dashboard', adminOnly: true },
      { key: 'sub-modules', label: 'Module Catalog', adminOnly: true },
      { key: 'sub-plans', label: 'Plans', adminOnly: true },
      { key: 'sub-all', label: 'All Subscriptions', adminOnly: true },
      { key: 'sub-pricing', label: 'Custom Pricing', adminOnly: true },
      { key: 'sub-config', label: 'Settings', adminOnly: true }
    ],

    'platform-reports': [
      { key: 'user-login-activity', label: 'User Login History', adminOnly: true }
    ],

    'bar-management': [
      { key: 'dashboard', label: 'Bar Dashboard', permission: 'dashboard' },
      { key: 'orders', label: 'Orders', permission: 'bar' },
      { key: 'station-display', label: 'Bar Station Display', permission: 'bar' },
      { key: 'inventory', label: 'Inventory', permission: 'bar' },
      { key: 'bar-masters', label: 'Masters', permission: 'masters' },
      { key: 'bar-reports', label: 'Reports', permission: 'bar' }
    ],
    kot: [
      { key: 'kot-dashboard', label: 'Dashboard', permission: 'kot' },
      { key: 'kot', label: 'Orders', permission: 'kot' },
      { key: 'kot-kitchen-punch', label: 'Kitchen Punch Board', permission: 'kot' },
      { key: 'kot-bill-reports', label: 'Billing & Settlement', permission: 'kot' },
      { key: 'kot-masters', label: 'Masters', permission: 'kot' }
    ],
    'food-inventory': [
      { key: 'food-pr', label: 'Purchase Requisition', permission: 'kot' },
      { key: 'food-po', label: 'Purchase Order', permission: 'kot' },
      { key: 'food-grn', label: 'Goods Receiving', permission: 'kot' },
      { key: 'food-store-issue', label: 'Store Requisition & Issue', permission: 'kot' },
      { key: 'food-stock-view', label: 'Stock Dashboard', permission: 'kot' },
      { key: 'food-stock-transfer', label: 'Stock Transfer', permission: 'kot' },
      { key: 'food-stock-adjustment', label: 'Stock Adjustment', permission: 'kot' },
      { key: 'food-physical-count', label: 'Physical Count', permission: 'kot' },
      { key: 'food-general-settings', label: 'General Settings', permission: 'kot' },
      { key: 'food-store-master', label: 'Store Master', permission: 'kot' },
      { key: 'food-item-master', label: 'Item Master', permission: 'kot' },
      { key: 'food-supplier-master', label: 'Supplier Master', permission: 'kot' },
      { key: 'food-reports', label: 'Reports', permission: 'kot' }
    ],
    accounting: [
      { key: 'gst-reports', label: 'GST Reports', permission: 'accounting' },
      { key: 'accounting-reconciliation', label: 'Cross-Module Reconciliation', permission: 'accounting' },
      { key: 'accounting-export', label: 'Export to Tally', permission: 'accounting' },
      { key: 'accounting-export-settings', label: 'Export Settings', permission: 'accounting' },
      { key: 'tally-live-push', label: 'Tally Live Push', permission: 'accounting' }
    ],
    expense: [
      { key: 'expense-dashboard', label: 'Dashboard', permission: 'expenses' },
      { key: 'expense-property-pnl', label: 'Property P&L', permission: 'expenses' },
      { key: 'revenue-target-dashboard', label: 'Revenue vs Target', permission: 'revenue_dashboard' },
      { key: 'revenue-reports', label: 'Revenue Reports', permission: 'revenue_dashboard' },
      { key: 'expense-entry', label: 'New Expense', permission: 'expenses' },
      { key: 'expense-list', label: 'Expense List', permission: 'expenses' },
      { key: 'expense-approval', label: 'Approval Queue', permission: 'expense_approve' },
      { key: 'expense-petty-cash', label: 'Petty Cash', permission: 'petty_cash' },
      { key: 'expense-reports', label: 'Reports', permission: 'expenses' },
      { key: 'expense-anomaly', label: 'Anomalies', permission: 'expenses' },
      { key: 'expense-masters', label: 'Masters', permission: 'expense_admin' }
    ],
    banquet: [
      { key: 'banquet-masters', label: 'Masters', permission: 'banquet' },
      { key: 'banquet-menu-master', label: 'Menu Master', permission: 'banquet' },
      { key: 'banquet-reports', label: 'Reports', permission: 'banquet' },
      { key: 'banquet-quotations-v2', label: 'Quotations', permission: 'banquet' },
      { key: 'banquet-quotations', label: 'Quotations (Legacy)', permission: 'banquet' },
      { key: 'banquet-bookings', label: 'Bookings & Invoices', permission: 'banquet' },
      { key: 'banquet-payments', label: 'Payments & Ledger', permission: 'banquet' },
      { key: 'banquet-calendar', label: 'Calendar', permission: 'banquet' },
      { key: 'banquet-intelligence', label: 'Competitor Intelligence', permission: 'banquet' },
      { key: 'banquet-demand-forecast', label: 'Demand Forecast', permission: 'banquet' },
      { key: 'banquet-pricing-advisor', label: 'Pricing Advisor', permission: 'banquet' },
      { key: 'banquet-variance-report', label: 'Variance Report', permission: 'banquet' },
      { key: 'banquet-crm-dashboard', label: 'CRM Dashboard', permission: 'banquet_crm' },
      { key: 'banquet-leads', label: 'CRM Leads', permission: 'banquet_crm' },
      { key: 'banquet-lead-conflicts', label: 'Lead Conflicts (AI)', permission: 'banquet_crm' },
      { key: 'banquet-pipeline', label: 'CRM Pipeline', permission: 'banquet_crm' },
      { key: 'banquet-follow-ups', label: 'CRM Follow-Ups', permission: 'banquet_crm' },
      { key: 'banquet-crm-config', label: 'CRM Config', permission: 'banquet_crm', adminOnly: true }
    ],
    'front-office': [
      // Restricted users have no Command Center to open these from, so list them.
      ...(isFoMenuUnrestricted ? [] : [
        { key: 'pms-reservations', label: 'Reservations', permission: 'front_office' },
        { key: 'pms-walkin', label: 'Walk-in Check-in', permission: 'front_office' }
      ]),
      { key: 'pms-dashboard', label: 'Dashboard', permission: 'front_office' },
      { key: 'pms-reports', label: 'Reports', permission: 'front_office' },
      { key: 'pms-command-center', label: 'Command Center', permission: 'front_office' },
      { key: 'pms-front-desk-board', label: 'Front Desk Board', permission: 'front_office' },
      { key: 'pms-rate-matrix', label: 'Rate Matrix', permission: 'front_office' },
      { key: 'pms-masters', label: 'Masters', permission: 'front_office' },
      { key: 'pms-upsell-products', label: 'Upsell Products', permission: 'front_office' },
      { key: 'pms-upsell-leaderboard', label: 'Upsell Leaderboard', permission: 'front_office' },
      { key: 'pms-guest-master', label: 'Guest Master', permission: 'front_office' },
      { key: 'pms-police-report', label: 'Police Report', permission: 'front_office' },
      { key: 'pms-invoice-register', label: 'Invoices', permission: 'front_office' },
      { key: 'pms-rate-quotation', label: 'Rate Quotations', permission: 'front_office' },
      { key: 'pms-agent-payments', label: 'Agent Payments', permission: 'front_office' },
      { key: 'pms-easeroom-cm', label: 'EaseRoom CM', permission: 'front_office' },
      { key: 'pms-room-inventory', label: 'Room Inventory', permission: 'front_office' },
      { key: 'pms-group-booking', label: 'Group Booking', permission: 'front_office' },
      { key: 'pms-night-audit', label: 'Night Audit', permission: 'front_office' },
      { key: 'pms-guest-requests', label: 'Guest Requests', permission: 'front_office' },
      { key: 'pms-guest-feedback', label: 'Guest Feedback', permission: 'front_office' },
      { key: 'pms-google-review', label: 'Google Review', permission: 'front_office' },
      { key: 'pms-gm-reports', label: 'GM Reports', permission: 'front_office' },
      { key: 'pms-door-audit', label: 'Door Audit', permission: 'door_audit' },
      { key: 'pms-invoice-amend-audit', label: 'Invoice Amendment Audit', permission: 'invoice_amend' },
      { key: 'pms-folio-void-audit', label: 'Folio Void Audit', permission: 'hotel_admin', adminOnly: true },
    ].filter((item) => foMenuAllows(item.key)),
    'ai-functions': [
      ...(isAiRevenueManagerActive ? [{ key: 'pms-revenue-manager', label: 'Competitor Settings', permission: 'ai_functions' }] : []),
      // Single menu entry; the Mapping surface is reached via the in-screen segmented toggle (RateShopperModeToggle).
      ...(isRateShopperActive ? [{ key: 'rate-shopper', label: 'Rate Shopper', permission: 'ai_functions' }] : []),
      ...(isPriceIntelligenceActive ? [{ key: 'price-intelligence', label: 'Price Intelligence', permission: 'ai_functions' }] : []),
      ...(isPriceIntelligenceActive ? [{ key: 'pickup-pace', label: 'Pickup & Pace', permission: 'ai_functions' }] : []),
      ...(isRevenueManagerRmsActive ? [{ key: 'revenue-manager-rms', label: 'Revenue Manager (RMS)', permission: 'ai_functions' }] : []),
      ...(isRateShopperActive ? [{ key: 'rate-shopper-reports', label: 'Reports & Analytics', permission: 'ai_functions' }] : []),
      ...(isAiGuestRecognitionActive ? [{ key: 'pms-guest-recognition', label: 'Guest Recognition', permission: 'ai_functions' }] : []),
      ...(isAiNoShowPredictorActive ? [{ key: 'pms-noshow-predictor', label: 'No-Show Predictor', permission: 'ai_functions' }] : []),
      ...(isAiOccupancyForecastActive ? [{ key: 'pms-occupancy-forecast', label: 'Occupancy Forecast', permission: 'ai_functions' }] : []),
      ...(isAiUpsellEngineActive ? [{ key: 'pms-upsell-engine', label: 'Upsell Engine', permission: 'ai_functions' }] : []),
      ...(isAiStaffAssistantActive ? [{ key: 'pms-staff-assistant', label: 'Staff Assistant', permission: 'ai_functions' }] : []),
      ...(isAiFolioAnomalyActive ? [{ key: 'pms-folio-anomaly', label: 'Folio Anomaly', permission: 'ai_functions' }] : []),
      ...(isAiNightAuditAnomalyActive ? [{ key: 'pms-night-audit-anomaly', label: 'Night Audit Anomaly', permission: 'ai_functions' }] : []),
      ...(isAiCorporateCreditRiskActive ? [{ key: 'pms-corporate-risk', label: 'Corporate Risk', permission: 'ai_functions' }] : [])
    ],
    housekeeping: [
      { key: 'pms-housekeeping', label: 'Operations', permission: 'housekeeping' },
      { key: 'hk-amenity-stock', label: 'Amenity Stock', permission: 'housekeeping' }
    ],
    stores: [
      { key: 'stores-stock', label: 'Stock on Hand', permission: 'stores' },
      { key: 'stores-ledger', label: 'Item Ledger', permission: 'stores' },
      { key: 'stores-opening', label: 'Opening Stock', permission: 'stores' },
      { key: 'stores-indents', label: 'Indents', permission: 'stores' },
      { key: 'stores-issues', label: 'Issue & Return', permission: 'stores' },
      { key: 'stores-transfers', label: 'Transfers', permission: 'stores' },
      { key: 'stores-wastage', label: 'Wastage & Adjustments', permission: 'stores' },
      { key: 'stores-count', label: 'Physical Count', permission: 'stores' },
      { key: 'stores-linen', label: 'Linen', permission: 'stores' },
      { key: 'stores-room-consumption', label: 'Room Consumption', permission: 'stores' },
      { key: 'stores-pm-kits', label: 'PM Kits', permission: 'stores' },
      { key: 'stores-fuel', label: 'Fuel Log', permission: 'stores' },
      { key: 'stores-pr', label: 'Purchase Requests', permission: 'stores' },
      { key: 'stores-approvals', label: 'Approvals', permission: 'stores' },
      { key: 'stores-po', label: 'Purchase Orders', permission: 'stores' },
      { key: 'stores-grn', label: 'Goods Receipt (GRN)', permission: 'stores' },
      { key: 'stores-bills', label: 'Vendor Bills & Payments', permission: 'stores' },
      { key: 'stores-vendors', label: 'Vendors', permission: 'stores' },
      { key: 'stores-items', label: 'Items', permission: 'stores' },
      { key: 'stores-masters', label: 'Stores & Masters', permission: 'stores' },
      { key: 'stores-settings', label: 'Settings & Access', permission: 'stores' },
      { key: 'stores-reports', label: 'Reports', permission: 'stores' }
    ],
    engineering: [
      { key: 'maint-dashboard', label: 'Dashboard', permission: 'maintenance' },
      { key: 'maint-work-orders', label: 'Work Orders' },
      { key: 'maint-preventive', label: 'Preventive Maintenance', permission: 'maintenance' },
      { key: 'maint-masters-hub', label: 'Masters Hub', permission: 'maintenance' },
      { key: 'maint-reports', label: 'Reports', permission: 'maintenance' }
    ],
    settings: [
      { key: 'chain-master', label: 'Chain Master', adminOnly: true },
      { key: 'country-master', label: 'Country Master', adminOnly: true },
      { key: 'currency-master', label: 'Currency Master', adminOnly: true },
      { key: 'timezone-master', label: 'Timezone Master', adminOnly: true },
      { key: 'channel-manager-settings', label: 'Channel Manager', adminOnly: true },
      { key: 'sms-providers-settings', label: 'SMS / Email Settings', adminOnly: true },
      { key: 'sms-templates-events', label: 'SMS Templates & Events', adminOnly: true },
      { key: 'whatsapp-platform-settings', label: 'WhatsApp Settings', adminOnly: true },
      { key: 'shorten-url-settings', label: 'Shorten URLs', adminOnly: true },
      { key: 'ai-features', label: 'AI Features', adminOnly: true },
      { key: 'competitor-rate-settings', label: 'Competitor Rate API', adminOnly: true },
      { key: 'rate-shopper-log', label: 'Rate Shopper Log', adminOnly: true },
      { key: 'training-material', label: 'Training Material', adminOnly: true },
      { key: 'nlp-config', label: 'NLP Config', adminOnly: true },
      { key: 'ai-usage-dashboard', label: 'AI Usage', adminOnly: true },
      { key: 'ticketing-settings', label: 'EASECARES & API Settings', adminOnly: true },
      { key: 'banquet-intel-config', label: 'Banquet Intelligence', adminOnly: true },
      { key: 'event-api-config', label: 'Event Calendar APIs', adminOnly: true },
      { key: 'event-sync-log', label: 'Events Log', adminOnly: true },
      { key: 'go-live-purge', label: 'Go Live', adminOnly: true }
    ]
  };

  const foodSectionMap = {
    operations: ['food-pr', 'food-po', 'food-grn', 'food-store-issue'],
    'stock-control': ['food-stock-view', 'food-stock-transfer', 'food-stock-adjustment', 'food-physical-count'],
    masters: ['food-general-settings', 'food-store-master', 'food-item-master', 'food-supplier-master'],
    reports: ['food-reports']
  };

  const foodSectionLabels = {
    operations: 'Operations',
    'stock-control': 'Stock Control',
    masters: 'Masters',
    reports: 'Reports'
  };
  const barSectionMap = {
    operations: ['orders'],
    'stock-control': ['inventory'],
    masters: ['bar-masters'],
    reports: ['bar-reports']
  };

  const barSectionLabels = {
    operations: 'Operations',
    'stock-control': 'Stock Control',
    masters: 'Masters',
    reports: 'Reports'
  };

  // Phase 2 nav: group each module's dropdown into labelled sub-groups (mega-menu).
  // Any screen not listed falls into a trailing "More" group, so nothing is lost.
  const menuSectionMap = {
    'front-office': [
      { label: 'Reservations', keys: ['pms-reservations', 'pms-walkin'] },
      { label: 'Operations', keys: ['pms-command-center', 'pms-front-desk-board', 'pms-dashboard', 'pms-night-audit', 'pms-group-booking'] },
      { label: 'Guests', keys: ['pms-guest-master', 'pms-guest-requests', 'pms-guest-feedback', 'pms-police-report', 'pms-google-review'] },
      { label: 'Rates & Billing', keys: ['pms-rate-matrix', 'pms-rate-quotation', 'pms-invoice-register', 'pms-agent-payments', 'pms-upsell-products', 'pms-upsell-leaderboard'] },
      { label: 'Inventory & Channels', keys: ['pms-room-inventory', 'pms-easeroom-cm'] },
      { label: 'Reports & Audit', keys: ['pms-reports', 'pms-gm-reports', 'pms-door-audit', 'pms-invoice-amend-audit', 'pms-folio-void-audit'] },
      { label: 'Setup', keys: ['pms-masters'] },
    ],
    kot: [
      { label: 'Operations', keys: ['kot-dashboard', 'kot', 'kot-kitchen-punch'] },
      { label: 'Billing', keys: ['kot-bill-reports'] },
      { label: 'Setup', keys: ['kot-masters'] },
    ],
    banquet: [
      { label: 'Sales', keys: ['banquet-quotations-v2', 'banquet-bookings', 'banquet-payments', 'banquet-calendar', 'banquet-quotations'] },
      { label: 'CRM', keys: ['banquet-crm-dashboard', 'banquet-leads', 'banquet-pipeline', 'banquet-follow-ups', 'banquet-lead-conflicts'] },
      { label: 'Intelligence', keys: ['banquet-intelligence', 'banquet-demand-forecast', 'banquet-pricing-advisor', 'banquet-variance-report'] },
      { label: 'Setup', keys: ['banquet-masters', 'banquet-menu-master', 'banquet-reports', 'banquet-crm-config'] },
    ],
    'hotel-config': [
      { label: 'Property & Users', keys: ['property-selector', 'property-master', 'users', 'role-templates'] },
      { label: 'Policies', keys: ['pms-policy-config', 'compliance-policy', 'hk-config', 'gst-master', 'room-tax-policy-master', 'general-settings'] },
      { label: 'Guest Experience', keys: ['guest-portal-settings', 'pre-checkin-config', 'guest-login-audit', 'theme-settings', 'hotel-ai-features'] },
      { label: 'Locks & Alerts', keys: ['lock-system', 'lock-agents', 'lock-authorizations', 'alert-settings'] },
      { label: 'Billing & Integrations', keys: ['my-subscription', 'my-subscription-invoices', 'tally-push-settings', 'email-settings', 'whatsapp-settings'] },
      { label: 'Help & Setup', keys: ['faq-assistant'] },
    ],
    expense: [
      { label: 'Overview', keys: ['expense-dashboard', 'expense-property-pnl', 'revenue-target-dashboard', 'revenue-reports'] },
      { label: 'Entry', keys: ['expense-entry', 'expense-list', 'expense-approval', 'expense-petty-cash'] },
      { label: 'Analysis & Setup', keys: ['expense-reports', 'expense-anomaly', 'expense-masters'] },
    ],
    'ai-functions': [
      { label: 'Revenue', keys: ['pms-revenue-manager', 'rate-shopper', 'rate-shopper-mapping', 'price-intelligence', 'pickup-pace', 'revenue-manager-rms', 'rate-shopper-reports', 'pms-occupancy-forecast', 'pms-noshow-predictor', 'pms-upsell-engine'] },
      { label: 'Guest & Risk', keys: ['pms-guest-recognition', 'pms-folio-anomaly', 'pms-night-audit-anomaly', 'pms-corporate-risk', 'pms-staff-assistant'] },
    ],
    stores: [
      { label: 'Stock', keys: ['stores-stock', 'stores-ledger', 'stores-opening'] },
      { label: 'Movements', keys: ['stores-indents', 'stores-issues', 'stores-transfers', 'stores-wastage', 'stores-count'] },
      { label: 'Purchase', keys: ['stores-pr', 'stores-approvals', 'stores-po', 'stores-grn', 'stores-bills', 'stores-vendors'] },
      { label: 'HK & Maintenance', keys: ['stores-linen', 'stores-room-consumption', 'stores-pm-kits', 'stores-fuel'] },
      { label: 'Setup', keys: ['stores-items', 'stores-masters', 'stores-settings'] },
      { label: 'Reports', keys: ['stores-reports'] },
    ],
    engineering: [
      { label: 'Operations', keys: ['maint-dashboard', 'maint-work-orders', 'maint-preventive'] },
      { label: 'Setup', keys: ['maint-masters-hub', 'maint-reports'] },
    ],
    accounting: [
      { label: 'Reports', keys: ['gst-reports', 'accounting-reconciliation'] },
      { label: 'Tally', keys: ['accounting-export', 'accounting-export-settings', 'tally-live-push'] },
    ],
    'bar-management': [
      { label: 'Operations', keys: ['dashboard', 'orders', 'station-display'] },
      { label: 'Stock', keys: ['inventory'] },
      { label: 'Setup', keys: ['bar-masters', 'bar-reports'] },
    ],
    settings: [
      { label: 'Reference Data', keys: ['chain-master', 'country-master', 'currency-master', 'timezone-master'] },
      { label: 'Integrations', keys: ['channel-manager-settings', 'competitor-rate-settings', 'rate-shopper-log', 'event-api-config', 'event-sync-log', 'ticketing-settings'] },
      { label: 'AI & Messaging', keys: ['ai-features', 'nlp-config', 'ai-usage-dashboard', 'sms-templates-events', 'sms-providers-settings', 'whatsapp-platform-settings', 'shorten-url-settings'] },
      { label: 'Intelligence', keys: ['banquet-intel-config'] },
      { label: 'Resources', keys: ['training-material'] },
      { label: 'System', keys: ['go-live-purge'] },
    ],
  };
  // Split filtered items into ordered groups; unlisted items → trailing "More".
  const groupSubItems = (items, moduleKey) => {
    const sections = menuSectionMap[moduleKey];
    if (!sections) return [{ label: null, items }];
    const byKey = new Map(items.map((i) => [i.key, i]));
    const used = new Set();
    const groups = [];
    sections.forEach((sec) => {
      const gi = sec.keys.map((k) => byKey.get(k)).filter(Boolean);
      gi.forEach((i) => used.add(i.key));
      if (gi.length) groups.push({ label: sec.label, items: gi });
    });
    const rest = items.filter((i) => !used.has(i.key));
    if (rest.length) groups.push({ label: 'More', items: rest });
    return groups;
  };

  const menuLabelByKey = Object.values(menuMap).flat().reduce((acc, item) => ({ ...acc, [item.key]: item.label }), {});

  const mainMenuLabels = {
    'hotel-config': 'Hotel Config',
    'front-office': 'Front Office',
    kot: 'KOT & POS',
    'food-inventory': 'Food Inventory',
    stores: 'Stores',
    banquet: 'Banquet',
    housekeeping: 'Housekeeping',
    'ai-functions': 'AI Functions',
    'bar-management': 'Bar Management',
    accounting: 'Accounting',
    expense: 'Expense & Profitability',
    subscription: 'Subscription',
    settings: 'Global Settings',
    'platform-reports': 'Reports'
  };

  const breadcrumbParts = useMemo(() => {
    const main = mainMenuLabels[activeMenu];
    if (!main) return [];
    if (activeMenu === 'food-inventory') {
      return [main, foodSectionLabels[foodSection] || '', menuLabelByKey[screen] || ''].filter(Boolean);
    }
    // 'rate-shopper-mapping' has no menu entry (reached via the in-screen toggle),
    // so give it an explicit breadcrumb label.
    const scr = menuLabelByKey[screen] || (screen === 'rate-shopper-mapping' ? 'Rate Shopper — Mapping' : '');
    return scr ? [main, scr] : [main];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMenu, screen, foodSection]);

  // ── Mobile back navigation ──
  // Screens are plain state (no router), so keep our own history of
  // {menu, screen}. The header back arrow pops it; the phone's Back key /
  // swipe-back is caught via one guard entry in browser history and does:
  // close the top popup (stay on screen) → previous screen → on the first
  // screen, "Press back again to exit" (double-back within 2s leaves).
  const navStackRef = useRef([]);
  const navGoingBackRef = useRef(false);
  const exitArmedAtRef = useRef(0);
  const phoneBackRef = useRef(() => true);
  const [navDepth, setNavDepth] = useState(0);
  const [backToast, setBackToast] = useState('');

  useEffect(() => { navStackRef.current = []; setNavDepth(0); }, [token]);

  useEffect(() => {
    if (!token) return;
    if (navGoingBackRef.current) { navGoingBackRef.current = false; return; }
    // Home screens start a fresh history, so they always show the ☰ menu.
    // The app auto-jumps between them after login / property pick, which
    // would otherwise leave Home looking like an inner screen.
    if (screen === 'property-selector' || screen === 'module-home') {
      navStackRef.current = [{ screen, menu: activeMenu }];
      setNavDepth(1);
      return;
    }
    const stack = navStackRef.current;
    const top = stack[stack.length - 1];
    if (top && top.screen === screen && top.menu === activeMenu) return;
    stack.push({ screen, menu: activeMenu });
    if (stack.length > 50) stack.shift();
    setNavDepth(stack.length);
  }, [screen, activeMenu, token]);

  const goBackScreen = () => {
    const stack = navStackRef.current;
    if (stack.length < 2) return false;
    stack.pop();
    const prev = stack[stack.length - 1];
    navGoingBackRef.current = true;
    setActiveMenu(prev.menu);
    setScreen(prev.screen);
    setNavDepth(stack.length);
    return true;
  };

  // Closes whatever popup is on top. App-level ones by state; screen modals
  // (each owns its own state) by finding the topmost full-screen fixed
  // overlay and pressing its Close / ✕ / Cancel button, else clicking its
  // backdrop, else sending Escape.
  const closeTopPopup = () => {
    if (mobileNavOpen) { setMobileNavOpen(false); return true; }
    if (cmdOpen) { setCmdOpen(false); return true; }
    if (changePasswordOpen) { setChangePasswordOpen(false); return true; }
    if (accountMenuOpen) { setAccountMenuOpen(false); return true; }
    if (supportMenuOpen) { setSupportMenuOpen(false); return true; }
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    let top = null;
    let topZ = -Infinity;
    document.querySelectorAll('body div').forEach((el) => {
      if (el.closest('.mobile-nav-drawer, .mobile-nav-overlay')) return;
      if (el.offsetWidth < vw * 0.9 || el.offsetHeight < vh * 0.9 || !el.children.length) return;
      const s = window.getComputedStyle(el);
      if (s.position !== 'fixed' || s.display === 'none' || s.visibility === 'hidden' || s.pointerEvents === 'none' || parseFloat(s.opacity) === 0) return;
      const z = parseInt(s.zIndex, 10);
      if (!(z >= 100)) return;
      if (z >= topZ) { top = el; topZ = z; }
    });
    if (!top) return false;
    const label = (b) => String(b.getAttribute('aria-label') || b.textContent || '').trim();
    const buttons = Array.from(top.querySelectorAll('button, [role="button"]')).filter((b) => b.offsetParent !== null && !b.disabled);
    const closeBtn = buttons.find((b) => /^[×✕✖xX]$/.test(label(b)) || /^([×✕✖]\s*)?close$/i.test(label(b)))
      || buttons.find((b) => /^cancel$/i.test(label(b)));
    if (closeBtn) { closeBtn.click(); return true; }
    top.dispatchEvent(new MouseEvent('click', { bubbles: true }));
    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    return true;
  };

  // Rebuilt every render so it sees current state. Returns false only when
  // the user is leaving the app.
  phoneBackRef.current = () => {
    if (closeTopPopup()) return true;
    if (goBackScreen()) return true;
    const now = Date.now();
    if (now - exitArmedAtRef.current < 2000) { exitArmedAtRef.current = 0; return false; }
    exitArmedAtRef.current = now;
    setBackToast('Press back again to exit');
    return true;
  };

  useEffect(() => {
    if (!backToast) return undefined;
    const t = setTimeout(() => setBackToast(''), 2000);
    return () => clearTimeout(t);
  }, [backToast]);

  useEffect(() => {
    if (!isMobile || !token) return undefined;
    const GUARD = { easepmsBackGuard: true };
    if (!window.history.state?.easepmsBackGuard) window.history.pushState(GUARD, '');
    const onPop = () => {
      if (phoneBackRef.current()) window.history.pushState(GUARD, '');
      else window.history.back();
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [isMobile, token]);

  // ── Portal segregation (Platform Console ↔ Hotel Workspace) ──
  // inConsole = admin viewing the Platform Console; inWorkspace = a hotel user,
  // or an admin who has entered a property. Governs NAV VISIBILITY only — not a
  // security boundary (routes stay server-guarded). See
  // docs/DESIGN_PLATFORM_CONSOLE_HOTEL_WORKSPACE.md
  const inConsole = role === 'admin' && portalMode === 'console';
  const inWorkspace = !inConsole;
  // The only Hotel Config items the Platform Console exposes.
  const CONSOLE_HOTEL_CONFIG_KEYS = ['property-selector', 'property-master', 'users'];
  // Portal-mode visibility for one sub-item. Console: Hotel Config is limited to
  // the 3 keys (subscription/settings groups are console-only at the tab level).
  // Workspace: console-only globals (adminOnly reference masters, Property Master,
  // Go-Live) are hidden.
  const portalAllowsItem = (item, menuKey) => {
    if (inConsole) {
      if (menuKey === 'hotel-config') return CONSOLE_HOTEL_CONFIG_KEYS.includes(item.key);
      return true;
    }
    if (item.adminOnly) return false;
    return true;
  };

  // ── Command palette (Ctrl-K / "/") — flat, permission-filtered jump list ──
  const paletteModuleDefs = [
    { key: 'hotel-config', label: 'Hotel Config', icon: '⚙️', show: true },
    { key: 'front-office', label: 'Front Office', icon: '🏨', show: hasFrontOfficeAccess && inWorkspace },
    { key: 'kot', label: 'KOT & POS', icon: '🍽️', show: hasKotAccess && inWorkspace },
    { key: 'food-inventory', label: 'Food Inventory', icon: '📦', show: hasFoodInventoryAccess && inWorkspace },
    { key: 'banquet', label: 'Banquet', icon: '🎉', show: hasBanquetAccess && inWorkspace },
    { key: 'housekeeping', label: 'Housekeeping', icon: '🧹', show: hasHousekeepingAccess && inWorkspace },
    { key: 'engineering', label: 'Engineering', icon: '🔧', show: hasMaintenanceAccess && inWorkspace },
    { key: 'stores', label: 'Stores', icon: '🏬', show: hasStoresAccess && inWorkspace },
    { key: 'ai-functions', label: 'AI Functions', icon: '🤖', show: hasAiFunctionsAccess && inWorkspace },
    { key: 'bar-management', label: 'Bar Management', icon: '🍺', show: hasBarAccess && inWorkspace },
    { key: 'accounting', label: 'Accounting', icon: '💰', show: hasAccountingAccess && inWorkspace },
    { key: 'expense', label: 'Expense & Profitability', icon: '💸', show: (hasExpenseAccess || hasRevenueDashboardAccess) && inWorkspace },
    { key: 'subscription', label: 'Subscription', icon: '💳', show: inConsole },
    { key: 'platform-reports', label: 'Reports', icon: '📊', show: inConsole },
    { key: 'settings', label: 'Global Settings', icon: '🛠️', show: inConsole },
  ];
  // Mirrors filterSubItems() in the top nav so the palette only lists reachable screens.
  const canAccessItem = (item, menuKey) => {
    if (!portalAllowsItem(item, menuKey)) return false;
    if (item.key === 'pms-policy-config') return role === 'admin' || String(role || '').toLowerCase() === 'hotel_admin' || Boolean(permissions?.hotel_admin) || hasFrontOfficePermission;
    if (item.adminOnly && role !== 'admin' && String(role || '').toLowerCase() !== 'hotel_admin' && !permissions?.hotel_admin) return false;
    if (!item.permission) return true;
    if (item.permission === 'bar') return hasBarAccess;
    if (item.permission === 'kot') return hasKotAccess;
    if (item.permission === 'banquet') return hasBanquetCoreAccess;
    if (item.permission === 'banquet_crm') return hasBanquetCrmAccess;
    if (item.permission === 'front_office') return hasFrontOfficeAccess;
    if (item.permission === 'housekeeping') return hasHousekeepingAccess;
    if (item.permission === 'maintenance') return hasMaintenanceAccess;
    if (item.permission === 'stores') return hasStoresAccess;
    if (item.permission === 'expenses') return hasExpenseAccess;
    if (item.permission === 'expense_approve') return hasExpenseApproveAccess;
    if (item.permission === 'expense_admin') return hasExpenseAdminAccess;
    if (item.permission === 'petty_cash') return hasPettyCashAccess;
    if (item.permission === 'revenue_dashboard') return hasRevenueDashboardAccess;
    return hasPermission(item.permission);
  };
  const commandItems = [];
  paletteModuleDefs.forEach((mod) => {
    if (!mod.show) return;
    (menuMap[mod.key] || []).forEach((item) => {
      if (!item || !item.key || !item.label) return;
      if (!canAccessItem(item, mod.key)) return;
      commandItems.push({ moduleKey: mod.key, moduleLabel: mod.label, screenKey: item.key, screenLabel: item.label });
    });
  });

  const handleCommandSelect = (item) => {
    setActiveMenu(item.moduleKey);
    if (item.moduleKey === 'food-inventory') {
      const sec = Object.keys(foodSectionMap).find((s) => (foodSectionMap[s] || []).includes(item.screenKey));
      if (sec) setFoodSection(sec);
    }
    setScreen(item.screenKey);
    setCmdOpen(false);
    setRecentScreens((prev) => {
      const next = [item.screenKey, ...prev.filter((k) => k !== item.screenKey)].slice(0, 8);
      try { localStorage.setItem('easepms_recent_screens', JSON.stringify(next)); } catch { /* ignore */ }
      return next;
    });
  };

  useEffect(() => {
    const onKey = (e) => {
      const tag = ((document.activeElement && document.activeElement.tagName) || '').toUpperCase();
      const typing = tag === 'INPUT' || tag === 'TEXTAREA' || (document.activeElement && document.activeElement.isContentEditable);
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); setCmdOpen((o) => !o); }
      else if (e.key === '/' && !typing) { e.preventDefault(); setCmdOpen(true); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  const canAccessFoodScreen = (screenKey) => {
    if (!hasFoodInventoryAccess) return false;
    if (role === 'admin' || Boolean(permissions?.hotel_admin) || Boolean(permissions?.food_admin)) return true;
    switch (screenKey) {
      case 'food-pr':
        return hasFoodKitchenAccess || hasFoodPurchaseStaffAccess || hasFoodPurchaseManagerAccess;
      case 'food-po':
        return hasFoodPurchaseManagerAccess;
      case 'food-grn':
        return hasFoodStoreReceiveAccess || hasFoodStoreManagerAccess || hasFoodStorekeeperAccess;
      case 'food-store-issue':
        return hasFoodKitchenAccess || hasFoodStoreIssueAccess || hasFoodStoreManagerAccess || hasFoodStorekeeperAccess;
      case 'food-stock-view':
        return hasFoodKitchenAccess || hasFoodStoreReceiveAccess || hasFoodStoreIssueAccess || hasFoodStoreManagerAccess || hasFoodStorekeeperAccess || hasFoodPurchaseManagerAccess || hasFoodCostControllerAccess;
      case 'food-stock-transfer':
      case 'food-stock-adjustment':
      case 'food-physical-count':
        return hasFoodStoreIssueAccess || hasFoodStoreManagerAccess || hasFoodStorekeeperAccess;
      case 'food-general-settings':
        return hasFoodPurchaseManagerAccess;
      case 'food-store-master':
      case 'food-item-master':
        return hasFoodStorekeeperAccess || hasFoodPurchaseManagerAccess;
      case 'food-supplier-master':
        return hasFoodPurchaseManagerAccess;
      case 'food-reports':
        return hasFoodCostControllerAccess;
      default:
        return false;
    }
  };

  const fetchDashboardStats = () => {
    if (!token || !hasPermission('dashboard')) return;
    if (!selectedPropertyId) return;

    fetch('/api/dashboard', {
      headers: { Authorization: `Bearer ${token}`, 'x-property-id': selectedPropertyId }
    })
      .then(res => res.json())
      .then(dashboardData => {
        if (!hasPermission('orders')) {
          setStats(dashboardData);
          return;
        }
        return fetch('/api/orders', {
          headers: { Authorization: `Bearer ${token}`, 'x-property-id': selectedPropertyId }
        })
          .then(res => res.json())
          .then(ordersData => {
            const orders = Array.isArray(ordersData) ? ordersData : [];
            const now = new Date();
            const todayOrders = orders.filter(order => {
              const d = new Date(order.order_date);
              return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
            });
            const todayOrdersCount = todayOrders.length;
            const todayOrderAmount = todayOrders.reduce(
              (sum, order) => sum + Number(order.subtotal || (Number(order.total_amount || 0) - Number(order.gst_amount || 0))),
              0
            );
            setStats({
              ...dashboardData,
              todayOrdersCount,
              todayOrderAmount
            });
          });
      })
      .catch(() => {});
  };

  const loadAccessibleProperties = () => {
    if (!token) return;
    fetch('/api/properties/accessible', {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        const allRows = Array.isArray(data) ? data : [];
        const rows = allRows.filter((p) => p.is_active !== false);
        setAccessibleProperties(rows);
        setAllPropertiesRaw(allRows);
        if (allRows.length > 0) {
          fetch('/api/properties/quick-stats', { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => r.json())
            .then((stats) => {
              if (!Array.isArray(stats)) return;
              const byId = {};
              stats.forEach((s) => { byId[String(s.property_id)] = s; });
              setPropertyQuickStats(byId);
            })
            .catch(() => {});
        }
        if (rows.length === 0) {
          setSelectedPropertyId('');
          localStorage.removeItem('selectedPropertyId');
          return;
        }
        const stored = localStorage.getItem('selectedPropertyId');
        const exists = rows.some((r) => String(r.id) === String(stored));
        if (exists) {
          setSelectedPropertyId(stored);
          return;
        }

        if (rows.length === 1) {
          const onlyPropertyId = String(rows[0].id);
          setSelectedPropertyId(onlyPropertyId);
          localStorage.setItem('selectedPropertyId', onlyPropertyId);
        } else {
          setSelectedPropertyId('');
          localStorage.removeItem('selectedPropertyId');
        }
      })
      .catch(() => setAccessibleProperties([]));
  };

  const clearKotOutletStorage = () => {
    for (let i = localStorage.length - 1; i >= 0; i -= 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith('selectedKotOutletId:')) localStorage.removeItem(key);
    }
  };

  const loadKotOutlets = () => {
    if (!token || !selectedProperty?.chain_id || !selectedProperty?.id) {
      setKotOutlets([]);
      setSelectedKotOutletId('');
      return;
    }
    const storageKey = `selectedKotOutletId:${selectedProperty.id}`;
    fetch(`/api/v1/core/outlets?property_id=${encodeURIComponent(selectedProperty.id)}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'x-chain-id': selectedProperty.chain_id,
        'x-property-id': selectedProperty.id
      }
    })
      .then((res) => res.json())
      .then((data) => {
        const hasKotScopeRole = (scope) => {
          const key = String(scope?.role_key || '').toUpperCase();
          return key === 'OUTLET_MANAGER' || key === 'CASHIER' || key === 'STEWARD' || key === 'KITCHEN'
            || key === 'PROPERTY_MANAGER' || key === 'CHAIN_ADMIN';
        };
        const inScope = (scope, outletId) => {
          if (!scope || !hasKotScopeRole(scope)) return false;
          const level = String(scope.scope_level || '').toUpperCase();
          if (level === 'CHAIN') return String(scope.chain_id) === String(selectedProperty.chain_id);
          if (level === 'PROPERTY') return String(scope.chain_id) === String(selectedProperty.chain_id) && String(scope.property_id) === String(selectedProperty.id);
          if (level === 'OUTLET') {
            return String(scope.chain_id) === String(selectedProperty.chain_id)
              && String(scope.property_id) === String(selectedProperty.id)
              && String(scope.outlet_id) === String(outletId);
          }
          return false;
        };

        const rows = Array.isArray(data)
          ? data.filter((o) => o.is_active !== false && o.module_kot_enabled !== false)
          : [];
        // Admins and hotel-admins see all outlets.
        // Users with explicit scopes are filtered to their assigned outlets.
        // Users with KOT/orders permission but no scopes assigned (e.g. legacy
        // property-manager accounts) fall back to seeing all outlets in the property.
        const hasKotPerm = Boolean(permissions?.kot) || Boolean(permissions?.orders) || Boolean(permissions?.hotel_admin);
        const noScopesAssigned = userScopes.length === 0;
        const authorizedRows = (role === 'admin' || Boolean(permissions?.hotel_admin) || (hasKotPerm && noScopesAssigned))
          ? rows
          : rows.filter((o) => userScopes.some((s) => inScope(s, o.id)));
        setKotOutlets(authorizedRows);
        if (!authorizedRows.length) {
          setSelectedKotOutletId('');
          localStorage.removeItem(storageKey);
          return;
        }
        const stored = localStorage.getItem(storageKey);
        // Functional update: reads the true current value at commit time instead
        // of the value closed over when this fetch started, so a concurrent
        // setSelectedKotOutletId('') (e.g. from the property-change effect) can't
        // make this check see a stale "already selected" state and skip restoring it.
        setSelectedKotOutletId((prevId) => {
          const activeExists = authorizedRows.some((o) => String(o.id) === String(prevId));
          if (activeExists) return prevId;
          const storedExists = authorizedRows.some((o) => String(o.id) === String(stored));
          if (storedExists) return String(stored);
          if (authorizedRows.length === 1) {
            const onlyId = String(authorizedRows[0].id);
            localStorage.setItem(storageKey, onlyId);
            return onlyId;
          }
          localStorage.removeItem(storageKey);
          return '';
        });
      })
      .catch(() => {
        setKotOutlets([]);
        setSelectedKotOutletId('');
      });
  };

  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    const storedRefreshToken = localStorage.getItem('refreshToken');
    const storedRole = localStorage.getItem('userRole');
    const storedPermissions = localStorage.getItem('userPermissions');
    const storedUsername = localStorage.getItem('username');
    const storedTime = localStorage.getItem('loginTime');

    if (storedToken && storedRole && storedTime) {
      const currentTime = Date.now();
      const sessionDuration = 30 * 60 * 1000;
      if (currentTime - parseInt(storedTime, 10) < sessionDuration) {
        const tokenPayload = decodeJwtPayload(storedToken);
        const tokenScopes = Array.isArray(tokenPayload?.scopes) ? tokenPayload.scopes : [];
        setToken(storedToken);
        setRefreshToken(storedRefreshToken || '');
        setRole(storedRole);
        setPermissions(storedPermissions ? JSON.parse(storedPermissions) : {});
        setUserScopes(tokenScopes);
        setUsername(storedUsername || '');
        localStorage.setItem('userScopes', JSON.stringify(tokenScopes));
      } else {
        localStorage.removeItem('authToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userRole');
        localStorage.removeItem('userPermissions');
        localStorage.removeItem('userScopes');
        localStorage.removeItem('loginTime');
        localStorage.removeItem('username');
        localStorage.removeItem('selectedPropertyId');
      }
    }

    // ── SSO Auto-Login: detect ?sso_token= in URL (CM→PMS redirect) ──
    const urlParams = new URLSearchParams(window.location.search);
    const ssoToken = urlParams.get('sso_token');
    if (ssoToken) {
      // Clean URL immediately (remove sso_token from address bar)
      const cleanUrl = window.location.origin + window.location.pathname;
      window.history.replaceState({}, document.title, cleanUrl);

      // Exchange SSO token for full session
      fetch('/api/v1/cross-auth/validate-sso', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sso_token: ssoToken }),
      })
        .then(r => r.json().then(d => ({ ok: r.ok, data: d })))
        .then(({ ok, data }) => {
          if (!ok || !data.token) {
            console.error('SSO login failed:', data.error || 'Unknown error');
            return;
          }
          const tokenPayload = decodeJwtPayload(data.token);
          const tokenScopes = Array.isArray(tokenPayload?.scopes) ? tokenPayload.scopes : [];
          setToken(data.token);
          setRefreshToken(data.refresh_token || '');
          setRole(data.role || 'staff');
          setPermissions(data.permissions || {});
          setUserScopes(tokenScopes);
          setUsername(data.username || '');
          setAccountMenuOpen(false);
          setActiveMenu('hotel-config');
          setScreen('property-selector');
          localStorage.setItem('authToken', data.token);
          localStorage.setItem('refreshToken', data.refresh_token || '');
          localStorage.setItem('userRole', data.role || 'staff');
          localStorage.setItem('userPermissions', JSON.stringify(data.permissions || {}));
          localStorage.setItem('userScopes', JSON.stringify(tokenScopes));
          localStorage.setItem('username', data.username || '');
          localStorage.setItem('loginTime', Date.now().toString());
        })
        .catch(err => console.error('SSO login error:', err));
    }
  }, []);

  useEffect(() => {
    if (token) {
      loadAccessibleProperties();
    }
  }, [token, role]);

  useEffect(() => {
    if (!token || !selectedPropertyId || !selectedProperty?.id) {
      setKotOutlets([]);
      setSelectedKotOutletId('');
      return;
    }
    loadKotOutlets();
  }, [token, selectedPropertyId, selectedProperty?.id]);

  useEffect(() => {
    setPmsWalkInPrefill(null);
  }, [selectedPropertyId]);

  useEffect(() => {
    fetchDashboardStats();
  }, [token, role, permissions, selectedPropertyId]);

  useEffect(() => {
    if (screen === 'dashboard') fetchDashboardStats();
  }, [screen]);

  useEffect(() => {
    if (!token) return;
    if (!selectedPropertyId) {
      setActiveMenu('hotel-config');
      setScreen('property-selector');
    }
  }, [selectedPropertyId, token]);

  useEffect(() => {
    if (!token) return;
    if (screen !== 'property-selector') return;
    if (!selectedPropertyId) return;
    if (accessibleProperties.length !== 1) return;
    setActiveMenu('hotel-config');
    setScreen('module-home');
  }, [token, screen, selectedPropertyId, accessibleProperties]);

  useEffect(() => {
    if (!token) return;
    if (screen === 'property-selector') {
      loadAccessibleProperties();
    }
  }, [screen, token]);

  // Poll open guest/housekeeping request counts for nav badges + sound alert
  useEffect(() => {
    if (!token || !selectedProperty?.id) return;
    let cancelled = false;
    const prevCountRef = { current: 0 };
    const pollBadgeCounts = async () => {
      if (cancelled) return;
      try {
        const hdrs = {
          Authorization: `Bearer ${token}`,
          'x-chain-id': selectedProperty.chain_id || '',
          'x-property-id': selectedProperty.id || ''
        };
        const [hkRes, svcRes] = await Promise.all([
          fetch('/api/v1/pms/housekeeping/requests?status=OPEN', { headers: hdrs }),
          fetch('/api/v1/pms/housekeeping/service-requests?status=OPEN', { headers: hdrs })
        ]);
        if (cancelled) return;
        const hkData = hkRes.ok ? await hkRes.json() : [];
        const svcData = svcRes.ok ? await svcRes.json() : [];
        const hkOpen = Array.isArray(hkData) ? hkData.length : 0;
        const svcOpen = Array.isArray(svcData) ? svcData.length : 0;
        const totalOpen = hkOpen + svcOpen;
        // Play alert sound when new requests arrive (reuse single AudioContext)
        if (totalOpen > prevCountRef.current && prevCountRef.current >= 0) {
          try {
            if (!window.__easepmsAudioCtx) {
              window.__easepmsAudioCtx = new (window.AudioContext || window.webkitAudioContext)();
            }
            const ctx = window.__easepmsAudioCtx;
            if (ctx.state === 'suspended') ctx.resume();
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.type = 'sine';
            osc.frequency.setValueAtTime(880, ctx.currentTime);
            osc.frequency.setValueAtTime(1046, ctx.currentTime + 0.15);
            gain.gain.setValueAtTime(0.3, ctx.currentTime);
            gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.4);
            osc.start(ctx.currentTime);
            osc.stop(ctx.currentTime + 0.4);
          } catch (_) { /* audio not available */ }
        }
        prevCountRef.current = totalOpen;
        setRequestBadgeCounts({ hkOpen, svcOpen });
      } catch (_) { /* non-critical */ }
    };
    pollBadgeCounts();
    const interval = setInterval(pollBadgeCounts, 30000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [token, selectedProperty?.id, selectedProperty?.chain_id]);

  // Poll today's guest feedback count for header notification icon
  useEffect(() => {
    if (!token || !selectedProperty?.id) { setFeedbackCount(0); return; }
    let cancelled = false;
    const pollFeedback = async () => {
      if (cancelled) return;
      try {
        const today = new Date().toISOString().slice(0, 10);
        const res = await fetch(`/api/v1/pms/guest-feedback?from=${today}&to=${today}&limit=1&offset=0`, {
          headers: { Authorization: `Bearer ${token}`, 'x-property-id': String(selectedProperty.id), 'x-chain-id': String(selectedProperty.chain_id || '') }
        });
        if (cancelled) return;
        if (res.ok) {
          const data = await res.json();
          setFeedbackCount(data.summary?.total || 0);
        }
      } catch (_) {}
    };
    pollFeedback();
    const interval = setInterval(pollFeedback, 60000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [token, selectedProperty?.id, selectedProperty?.chain_id]);

  // Poll pending guest request count for header notification bell
  useEffect(() => {
    if (!token || !selectedProperty?.id) { setGuestRequestCount(0); return; }
    let cancelled = false;
    const pollRequests = async () => {
      if (cancelled) return;
      try {
        const res = await fetch('/api/v1/pms/guest-requests/pending-count', {
          headers: { Authorization: `Bearer ${token}`, 'x-property-id': String(selectedProperty.id), 'x-chain-id': String(selectedProperty.chain_id || '') }
        });
        if (cancelled) return;
        if (res.ok) {
          const data = await res.json();
          setGuestRequestCount(data.count || 0);
        }
      } catch (_) {}
    };
    pollRequests();
    const interval = setInterval(pollRequests, 30000);
    return () => { cancelled = true; clearInterval(interval); };
  }, [token, selectedProperty?.id, selectedProperty?.chain_id]);

  // Check if ticketing is enabled for this property
  useEffect(() => {
    if (!token || !selectedProperty?.id) { setTicketingEnabled(false); return; }
    fetch('/api/v1/support/ticketing-enabled', {
      headers: { Authorization: `Bearer ${token}`, 'x-property-id': String(selectedProperty.id) }
    })
      .then(r => r.ok ? r.json() : { enabled: false })
      .then(data => setTicketingEnabled(Boolean(data.enabled)))
      .catch(() => setTicketingEnabled(false));
  }, [token, selectedProperty?.id]);

  // Load AI feature toggles for selected property
  useEffect(() => {
    if (!token || !selectedProperty?.id) { setAiFeatures({}); return; }
    (async () => {
      try {
        const res = await fetch('/api/v1/ai/features', {
          headers: { Authorization: `Bearer ${token}`, 'x-chain-id': selectedProperty.chain_id || '', 'x-property-id': selectedProperty.id || '' }
        });
        if (res.ok) { const d = await res.json(); setAiFeatures(d.features || {}); }
      } catch (_) { /* non-critical */ }
    })();
  }, [token, selectedProperty?.id, selectedProperty?.chain_id]);

  // Ref to hold current token for fetch interceptor (avoids stale closure)
  const tokenRef = useRef(token);
  useEffect(() => { tokenRef.current = token; }, [token]);
  const refreshTokenRef = useRef(refreshToken);
  useEffect(() => { refreshTokenRef.current = refreshToken; }, [refreshToken]);
  const isRefreshingRef = useRef(false);
  const refreshQueueRef = useRef([]);

  useEffect(() => {
    const originalFetch = window.fetch.bind(window);

    const clearSession = () => {
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userRole');
      localStorage.removeItem('userPermissions');
      localStorage.removeItem('userScopes');
      localStorage.removeItem('loginTime');
      localStorage.removeItem('username');
      localStorage.removeItem('selectedPropertyId');
      window.location.reload();
    };

    const doRefresh = async () => {
      const rt = refreshTokenRef.current || localStorage.getItem('refreshToken');
      if (!rt) return null;
      try {
        const res = await originalFetch('/api/auth/refresh', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ refresh_token: rt })
        });
        if (!res.ok) return null;
        const data = await res.json();
        if (!data.token) return null;
        // Update tokens in state and storage
        tokenRef.current = data.token;
        refreshTokenRef.current = data.refresh_token || '';
        setToken(data.token);
        setRefreshToken(data.refresh_token || '');
        setPermissions(data.permissions || {});
        localStorage.setItem('authToken', data.token);
        localStorage.setItem('refreshToken', data.refresh_token || '');
        if (data.permissions) localStorage.setItem('userPermissions', JSON.stringify(data.permissions));
        return data.token;
      } catch (_) {
        return null;
      }
    };

    const refreshAndRetry = (args) => {
      return new Promise((resolve) => {
        refreshQueueRef.current.push({ args, resolve });
        if (isRefreshingRef.current) return; // another refresh in progress, will be handled
        isRefreshingRef.current = true;
        doRefresh().then((newToken) => {
          const queue = refreshQueueRef.current.splice(0);
          isRefreshingRef.current = false;
          if (!newToken) {
            // Refresh failed — logout
            queue.forEach(item => item.resolve(null));
            if (!authPopupActiveRef.current) {
              authPopupActiveRef.current = true;
              console.warn('[EASEPMS] Session expired — logging out.');
              window.setTimeout(clearSession, 100);
            }
            return;
          }
          // Retry all queued requests with new token
          queue.forEach(item => {
            const [input, init] = item.args;
            const newInit = { ...(init || {}) };
            newInit.headers = { ...(newInit.headers || {}), Authorization: `Bearer ${newToken}` };
            originalFetch(input, newInit).then(item.resolve);
          });
        });
      });
    };

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      const url = typeof args[0] === 'string' ? args[0] : String(args[0]?.url || '');
      const isAuthCall = url.includes('/api/auth/login') || url.includes('/api/auth/refresh');

      // On 401 — hard session expired (refresh token also invalid)
      if (response.status === 401 && !isAuthCall && tokenRef.current && !authPopupActiveRef.current) {
        authPopupActiveRef.current = true;
        console.warn('[EASEPMS] Session expired — logging out.');
        window.setTimeout(clearSession, 100);
        return response;
      }

      // On 403 with expired token — try silent refresh. A permission 403
      // (valid token, missing role/permission) is returned as-is: refreshing
      // can't fix it, and a failed refresh would log the user out.
      if (response.status === 403 && !isAuthCall && tokenRef.current) {
        const body = await response.clone().json().catch(() => null);
        const err = String(body?.error || '').toLowerCase();
        if (!err.includes('invalid or expired token') && !err.includes('invalid token type')) return response;
        const retryResponse = await refreshAndRetry(args);
        if (retryResponse) return retryResponse;
      }

      return response;
    };
    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  // Close mobile nav when screen changes; auto-expand active menu when drawer opens
  useEffect(() => { setMobileNavOpen(false); }, [screen]);
  useEffect(() => { if (mobileNavOpen) setMobileExpandedMenu(activeMenu); }, [mobileNavOpen]);

  if (!token) {
    return (
      <Login
        onLogin={(t, r, p, u, rt) => {
          const tokenPayload = decodeJwtPayload(t);
          const tokenScopes = Array.isArray(tokenPayload?.scopes) ? tokenPayload.scopes : [];
          setToken(t);
          setRefreshToken(rt || '');
          setRole(r);
          setPermissions(p || {});
          setUserScopes(tokenScopes);
          setUsername(u || '');
          setAccountMenuOpen(false);
          // Admins start in the Platform Console; everyone else in the Hotel Workspace.
          setPortalMode(r === 'admin' ? 'console' : 'workspace');
          setActiveMenu('hotel-config');
          setScreen('property-selector');
          localStorage.setItem('authToken', t);
          localStorage.setItem('refreshToken', rt || '');
          localStorage.setItem('userRole', r);
          localStorage.setItem('userPermissions', JSON.stringify(p || {}));
          localStorage.setItem('userScopes', JSON.stringify(tokenScopes));
          localStorage.setItem('username', u || '');
          localStorage.setItem('loginTime', Date.now().toString());
        }}
      />
    );
  }

  const gotoModuleHome = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Select a property first');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('hotel-config');
    setScreen('module-home');
  };

  // Admin enters a property's Hotel Workspace from the Platform Console.
  const enterHotelWorkspace = () => {
    if (role === 'admin') setPortalMode('workspace');
    gotoModuleHome();
  };

  // Admin returns from a Hotel Workspace to the Platform Console.
  const backToPlatformConsole = () => {
    setPortalMode('console');
    setModuleAccessError('');
    setAccountMenuOpen(false);
    setActiveMenu('hotel-config');
    setScreen('property-selector');
  };

  const openBarManagement = () => {
    setModuleAccessError('');
    if (!selectedPropertyId) {
      setModuleAccessError('Select a property first from Hotel Config');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    if (!isBarModuleEnabledForProperty) {
      setModuleAccessError('Bar Management is disabled for this property commercial plan.');
      setActiveMenu('hotel-config');
      setScreen('module-home');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('bar-management');
    if (hasPermission('dashboard')) {
      setScreen('dashboard');
    } else if (hasBarAccess) {
      setScreen('orders');
    } else if (hasMastersAccess) {
      setScreen('bar-masters');
    }
  };

  const openKot = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Select a property first from Hotel Config');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    if (!isKotModuleEnabledForProperty) {
      setModuleAccessError('KOT & POS is disabled for this property commercial plan.');
      setActiveMenu('hotel-config');
      setScreen('module-home');
      return;
    }
    if (!selectedKotOutletId) {
      setModuleAccessError('Select outlet from top-right dropdown');
      setActiveMenu('hotel-config');
      setScreen('module-home');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('kot');
    setScreen('kot');
  };

  // Jump straight to an open F&B bill from the Command Center Night Audit
  // Exceptions alert. Unlike openKot/openBarManagement, we already have a
  // concrete outlet_id from the bill itself, so we skip their "no outlet
  // selected" guard and set it directly.
  const openExceptionBill = (bill) => {
    if (!bill?.outlet_id) return;
    const outletId = String(bill.outlet_id);
    setSelectedKotOutletId(outletId);
    if (selectedProperty?.id) {
      try { localStorage.setItem(`selectedKotOutletId:${selectedProperty.id}`, outletId); } catch { /* ignore */ }
    }
    setModuleAccessError('');
    if (String(bill.outlet_type || '').toUpperCase() === 'BAR') {
      setActiveMenu('bar-management');
      setScreen('orders');
      setPendingBarOrderId(bill.order_id);
    } else {
      setActiveMenu('kot');
      setScreen('kot');
      setPendingKotBillId(bill.bill_id);
    }
  };

  const openFoodInventory = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Select a property first from Hotel Config');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    if (!isFoodInventoryModuleEnabledForProperty) {
      setModuleAccessError('Food Inventory is disabled for this property commercial plan.');
      setActiveMenu('hotel-config');
      setScreen('module-home');
      return;
    }
    setActiveMenu('food-inventory');
    setFoodSection('operations');
    const firstFoodScreen = (menuMap['food-inventory'] || []).find((item) => canAccessFoodScreen(item.key))?.key || 'food-pr';
    setScreen(firstFoodScreen);
  };

  const openAccounting = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Select a property first from Hotel Config');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('accounting');
    setScreen('accounting-export');
  };

  const openExpense = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Select a property first from Hotel Config');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('expense');
    // Pick the first sub-item the user actually has permission for. If they
    // only have revenue_dashboard (no expense access) we still want the
    // module to open to a valid screen rather than blank.
    const first = (menuMap['expense'] || []).find(item => {
      if (item.permission === 'expenses')        return hasExpenseAccess;
      if (item.permission === 'expense_approve') return hasExpenseApproveAccess;
      if (item.permission === 'expense_admin')   return hasExpenseAdminAccess;
      if (item.permission === 'petty_cash')      return hasPettyCashAccess;
      if (item.permission === 'revenue_dashboard') return hasRevenueDashboardAccess;
      return false;
    })?.key || (hasRevenueDashboardAccess ? 'revenue-target-dashboard' : 'expense-dashboard');
    setScreen(first);
  };

  const openBanquet = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Select a property first from Hotel Config');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('banquet');
    setScreen(hasBanquetCoreAccess ? 'banquet-masters' : 'banquet-crm-dashboard');
  };

  const openFrontOffice = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Please select a property before opening Front Office.');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    if (!isFrontOfficeModuleEnabledForProperty) {
      setModuleAccessError('PMS / Front Office is disabled for this property commercial plan.');
      setActiveMenu('hotel-config');
      setScreen('module-home');
      return;
    }
    if (!hasFrontOfficePermission) {
      setModuleAccessError('You do not have Front Office permission for this property.');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    if (!foFirstScreen) {
      setModuleAccessError('No Front Office menus are assigned to you. Ask your admin to tick them under Users.');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('front-office');
    setScreen(foMenuAllows('pms-command-center') ? 'pms-command-center' : foFirstScreen);
  };

  const openWalkInFromRack = (room) => {
    if (!room?.room_id) return;
    setModuleAccessError('');
    setActiveMenu('front-office');
    setPmsWalkInPrefill({
      room_id: Number(room.room_id),
      room_number: room.room_number || '',
      room_type_name: room.room_type_name || '',
      ts: Date.now()
    });
    setScreen('pms-walkin');
  };

  const openEditReservationFromRack = (reservationId) => {
    if (!reservationId) return;
    setModuleAccessError('');
    setActiveMenu('front-office');
    setOpenEditReservationId(reservationId);
    setScreen('pms-reservations');
  };

  const reCheckInGuest = (guest) => {
    if (!guest) return;
    setModuleAccessError('');
    setActiveMenu('front-office');
    setPrefillGuestForWalkIn({ ...guest, ts: Date.now() });
    setScreen('pms-walkin');
  };

  const openNewReservation = () => {
    setModuleAccessError('');
    setActiveMenu('front-office');
    setOpenEditReservationId(null);
    setScreen('pms-reservations');
  };

  const openNewWalkIn = () => {
    setModuleAccessError('');
    setActiveMenu('front-office');
    setPmsWalkInPrefill(null);
    setScreen('pms-walkin');
  };

  const makeReservationForGuest = (guest) => {
    if (!guest) return;
    setModuleAccessError('');
    setActiveMenu('front-office');
    setPrefillGuestForReservation({ ...guest, ts: Date.now() });
    setScreen('pms-reservations');
  };

  const openHousekeeping = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Please select a property before opening Housekeeping.');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    if (!isHousekeepingModuleEnabledForProperty) {
      setModuleAccessError('');
      return;
    }
    if (!hasHousekeepingPermission) {
      setModuleAccessError('You do not have Housekeeping permission for this property.');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('housekeeping');
    setScreen('pms-housekeeping');
  };

  const openEngineering = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Please select a property before opening Engineering.');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('engineering');
    setScreen('maint-dashboard');
  };

  const openStores = () => {
    if (!selectedPropertyId) {
      setModuleAccessError('Please select a property before opening Stores.');
      setActiveMenu('hotel-config');
      setScreen('property-selector');
      return;
    }
    setModuleAccessError('');
    setActiveMenu('stores');
    setScreen('stores-stock');
  };

  const performLogout = () => {
    const activeToken = token;
    setAccountMenuOpen(false);
    if (activeToken) {
      fetch('/api/auth/logout', {
        method: 'POST',
        headers: { Authorization: `Bearer ${activeToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ refresh_token: refreshToken || null })
      }).catch(() => {});
    }
    setToken(null);
    setRefreshToken('');
    setRole(null);
    setPermissions({});
    setUserScopes([]);
    setUsername('');
    setAccessibleProperties([]);
    setSelectedPropertyId('');
    setKotOutlets([]);
    setSelectedKotOutletId('');
    setPortalMode('console');
    setActiveMenu('hotel-config');
    setScreen('property-selector');
    localStorage.removeItem('easepms_portal_mode');
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userPermissions');
    localStorage.removeItem('userScopes');
    localStorage.removeItem('loginTime');
    localStorage.removeItem('username');
    localStorage.removeItem('selectedPropertyId');
    clearKotOutletStorage();
    resetTheme();
  };

  const handleMenuEnter = (menuKey, e) => {
    clearTimeout(hoverTimeoutRef.current);
    const btn = e?.currentTarget;
    if (btn) {
      const rect = btn.getBoundingClientRect();
      setDropdownPos({ top: rect.bottom, left: rect.left });
    }
    setHoveredMenu(menuKey);
  };
  const handleMenuLeave = () => { hoverTimeoutRef.current = setTimeout(() => setHoveredMenu(null), 250); };

  // --- New ePay-inspired styles ---
  const headerStyle = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: isMobile ? '0.5rem' : '1rem', background: '#fff', padding: isMobile ? '0.5rem 0.75rem' : '0.6rem 1.2rem', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0, zIndex: 50, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' };
  const sidebarOn = navMode === 'sidebar' && !isMobile;
  const RAIL_W = 60;
  const navBarStyle = { display: (isMobile || sidebarOn) ? 'none' : 'flex', alignItems: 'center', background: 'linear-gradient(135deg, var(--theme-nav-from) 0%, var(--theme-nav-to) 100%)', padding: '0', height: '48px', overflow: 'visible', position: 'sticky', top: '52px', zIndex: 49 };
  const navScrollArrowStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', minWidth: '28px', height: '100%', background: 'rgba(0,0,0,0.18)', border: 'none', color: '#fff', cursor: 'pointer', fontSize: '0.85rem', fontWeight: 700, zIndex: 2, flexShrink: 0 };
  const navItemStyle = { display: 'flex', alignItems: 'center', gap: '0.35rem', padding: '0.45rem 0.75rem', color: 'rgba(255,255,255,0.88)', border: 'none', background: 'transparent', cursor: 'pointer', fontWeight: '500', whiteSpace: 'nowrap', fontSize: '0.82rem', borderBottom: '2px solid transparent', height: '100%', position: 'relative', transition: 'all 0.15s' };
  const navItemActiveStyle = { ...navItemStyle, color: '#fff', background: 'rgba(255,255,255,0.12)', borderBottom: '2px solid #fff', fontWeight: '700' };
  const navItemHoverStyle = { ...navItemStyle, color: '#fff', background: 'rgba(255,255,255,0.08)' };
  const dropdownStyle = { position: 'absolute', top: '100%', left: 0, minWidth: '220px', background: '#fff', borderRadius: '0 0 10px 10px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)', border: '1px solid #e5e7eb', borderTop: 'none', zIndex: 60, padding: '0.35rem 0', maxHeight: '420px', overflowY: 'auto' };
  const dropdownItemStyle = { display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.55rem 1rem', fontSize: '0.82rem', color: '#374151', background: 'transparent', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left', fontWeight: '500', transition: 'all 0.1s' };
  const infoPillStyle = { fontSize: '0.72rem', padding: '0.2rem 0.6rem', borderRadius: '999px', fontWeight: '600', border: '1px solid #e5e7eb', background: '#f9fafb', color: '#374151', whiteSpace: 'nowrap' };
  const subNavStyle = { display: 'flex', gap: '0', background: '#fff', padding: '0 0.5rem', borderBottom: '2px solid #e8ecf3', overflowX: 'auto', whiteSpace: 'nowrap', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' };
  const tabStyle = { padding: '0.6rem 0.95rem', background: 'transparent', color: '#6b7280', border: 'none', borderBottom: '2px solid transparent', borderRadius: '0', cursor: 'pointer', fontWeight: '500', whiteSpace: 'nowrap', fontSize: '0.875rem', flexShrink: 0 };
  const activeTabStyle = { ...tabStyle, color: 'var(--theme-tab-active-text)', borderBottom: '2px solid var(--theme-tab-active-border)', fontWeight: '700' };
  // Legacy aliases kept for any other uses
  const navBtnStyle = navItemStyle;
  const navActiveBtnStyle = navItemActiveStyle;
  const buttonStyle = navItemStyle;
  const activeStyle = navItemActiveStyle;
  const foodSectionTabs = Object.keys(foodSectionMap);
  const foodSectionItems = (menuMap['food-inventory'] || [])
    .filter((item) => (foodSectionMap[foodSection] || []).includes(item.key))
    .filter((item) => canAccessFoodScreen(item.key));

  return (
    <div className={`app-root min-h-screen bg-slate-50 text-slate-800${isMobile ? ' is-mobile' : ''}`} style={{ paddingLeft: sidebarOn ? RAIL_W : 0, transition: 'padding-left 0.15s ease' }}>
      {/* ── OFFLINE BANNER ── */}
      {!isOnline && (
        <div style={{ background: '#fbbf24', color: '#78350f', textAlign: 'center', padding: '0.4rem 1rem', fontSize: '0.82rem', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4rem' }}>
          <span style={{ fontSize: '1rem' }}>&#9888;</span> You are offline. Some features may not be available.
        </div>
      )}

      {/* ── WHITE TOP HEADER (ePay style) ── */}
      <header style={headerStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '0.55rem' : '0.75rem', ...(isMobile ? { minWidth: 0, flex: 1 } : {}) }}>
          {/* Mobile: back arrow replaces the hamburger once past the first screen */}
          {isMobile && navDepth > 1 && (
            <button onClick={goBackScreen} aria-label="Back"
              style={{ width: '40px', height: '40px', borderRadius: '8px', background: '#eef2ff', border: '1px solid #c7d2fe', color: 'var(--theme-primary-dark)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, flexShrink: 0 }}>
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M15 5l-7 7 7 7" /></svg>
            </button>
          )}
          {isMobile && navDepth <= 1 && (
            <button onClick={() => setMobileNavOpen(true)} aria-label="Open menu"
              style={{ width: '40px', height: '40px', borderRadius: '8px', background: 'linear-gradient(135deg, var(--theme-nav-from), var(--theme-nav-to))', border: 'none', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '4px', padding: 0, flexShrink: 0 }}>
              <span style={{ width: '18px', height: '2px', background: '#fff', borderRadius: '1px' }} />
              <span style={{ width: '18px', height: '2px', background: '#fff', borderRadius: '1px' }} />
              <span style={{ width: '18px', height: '2px', background: '#fff', borderRadius: '1px' }} />
            </button>
          )}
          {!isMobile && (selectedProperty?.logo_url ? (
            <img src={selectedProperty.logo_url} alt={`${selectedProperty.name || 'Property'} logo`}
              style={{ width: '38px', height: '38px', borderRadius: '8px', objectFit: 'cover', border: '1px solid #e5e7eb', background: '#fff' }} />
          ) : (
            <div style={{ width: '38px', height: '38px', borderRadius: '8px', background: 'linear-gradient(135deg, var(--theme-nav-from), var(--theme-nav-to))', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: '0.9rem' }}>E</div>
          ))}
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 700, fontSize: isMobile ? '0.85rem' : '1rem', color: 'var(--theme-primary-dark)', lineHeight: 1.2 }}>EASEPMS</div>
            {!isMobile && <div style={{ fontSize: '0.68rem', color: '#9ca3af', fontWeight: 500 }}>Hospitality Experience Management Platform</div>}
            {isMobile && breadcrumbParts.length > 0 && (
              <div style={{ fontSize: '0.68rem', color: '#6b7280', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {breadcrumbParts.join(' › ')}
              </div>
            )}
          </div>
        </div>

        {/* Mobile (Option A): one row — Guest Requests, Search, Account only;
            Feedback / Help / Support live in the Account menu, Platform
            Console in the drawer. */}
        <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? '0.4rem' : '0.5rem', flexWrap: isMobile ? 'nowrap' : 'wrap', justifyContent: 'flex-end', flexShrink: 0 }}>
          {/* Admin: Back to Platform Console when inside a Hotel Workspace */}
          {!isMobile && role === 'admin' && portalMode === 'workspace' && (
            <button onClick={backToPlatformConsole} title="Return to the Platform Console"
              style={{ ...infoPillStyle, cursor: 'pointer', background: '#eef2ff', borderColor: '#c7d2fe', color: '#4338ca', fontWeight: 600 }}>
              &larr; Platform Console
            </button>
          )}
          {!isMobile && inConsole && (
            <div style={{ ...infoPillStyle, background: '#eef2ff', borderColor: '#c7d2fe', color: '#4338ca', fontWeight: 600 }}>
              Platform Console
            </div>
          )}
          {!isMobile && !inConsole && (
            <div title="Hotel Workspace" style={{ ...infoPillStyle, background: selectedProperty ? '#eff6ff' : '#fef3f2', borderColor: selectedProperty ? '#bfdbfe' : '#fecaca', color: selectedProperty ? '#1e40af' : '#991b1b' }}>
              {selectedProperty
                ? (String(selectedProperty.code || '').toLowerCase() === String(selectedProperty.name || '').toLowerCase()
                    ? `\ud83c\udfe8 ${selectedProperty.name}`
                    : `\ud83c\udfe8 ${selectedProperty.code} \u2014 ${selectedProperty.name}`)
                : 'No Property'}
            </div>
          )}

          {!isMobile && (
            <label title="Outlet" style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', fontSize: '0.75rem', color: '#6b7280', fontWeight: 500 }}>
              <select value={selectedKotOutletId}
                onChange={(e) => {
                  const nextId = String(e.target.value || '');
                  setSelectedKotOutletId(nextId);
                  if (nextId) setModuleAccessError('');
                  if (selectedProperty?.id) {
                    const key = `selectedKotOutletId:${selectedProperty.id}`;
                    if (nextId) localStorage.setItem(key, nextId);
                    else localStorage.removeItem(key);
                  }
                }}
                style={{ padding: '0.25rem 0.5rem', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff', color: '#1f2937', minWidth: '120px', maxWidth: '180px', fontSize: '0.78rem', fontWeight: 500 }}>
                <option value="">Select Outlet</option>
                {kotOutlets.map((o) => <option key={o.id} value={o.id}>{o.code ? `${o.code} - ${o.name}` : (o.name || o.id)}</option>)}
              </select>
            </label>
          )}

          <div style={{ display: 'flex', alignItems: 'center', gap: '0.3rem' }}>
          {!isMobile && hasFrontOfficeAccess && (
            <button onClick={() => { setActiveMenu('front-office'); setScreen('pms-guest-feedback'); }}
              title="Guest Feedback"
              style={{ position: 'relative', width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #e5e7eb', background: feedbackCount > 0 ? '#fef3c7' : '#f9fafb', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#fde68a'; e.currentTarget.style.transform = 'scale(1.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = feedbackCount > 0 ? '#fef3c7' : '#f9fafb'; e.currentTarget.style.transform = 'scale(1)'; }}>
              {'\u2B50'}
              {feedbackCount > 0 && (
                <span style={{ position: 'absolute', top: '-4px', right: '-4px', background: '#ef4444', color: '#fff', borderRadius: '999px', minWidth: '18px', height: '18px', fontSize: '0.62rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px', border: '2px solid #fff' }}>
                  {feedbackCount > 99 ? '99+' : feedbackCount}
                </span>
              )}
            </button>
          )}

          {hasFrontOfficeAccess && (
            <button onClick={() => { setActiveMenu('front-office'); setScreen('pms-guest-requests'); }}
              title="Guest Requests"
              style={{ position: 'relative', width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #e5e7eb', background: guestRequestCount > 0 ? '#ede9fe' : '#f9fafb', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', transition: 'all 0.2s' }}
              onMouseEnter={e => { e.currentTarget.style.background = '#ddd6fe'; e.currentTarget.style.transform = 'scale(1.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = guestRequestCount > 0 ? '#ede9fe' : '#f9fafb'; e.currentTarget.style.transform = 'scale(1)'; }}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6366f1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
              </svg>
              {guestRequestCount > 0 && (
                <span style={{ position: 'absolute', top: '-4px', right: '-4px', background: '#ef4444', color: '#fff', borderRadius: '999px', minWidth: '18px', height: '18px', fontSize: '0.62rem', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px', border: '2px solid #fff' }}>
                  {guestRequestCount > 99 ? '99+' : guestRequestCount}
                </span>
              )}
            </button>
          )}

          {!isMobile && (<>
          <button onClick={() => { setActiveMenu('hotel-config'); setScreen('faq-assistant'); }}
            title="FAQ / Help"
            style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1px solid #e5e7eb', background: '#f9fafb', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.05rem', transition: 'all 0.2s' }}
            onMouseEnter={e => { e.currentTarget.style.background = '#e0f2fe'; e.currentTarget.style.transform = 'scale(1.1)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#f9fafb'; e.currentTarget.style.transform = 'scale(1)'; }}>
            ❓
          </button>

          <div style={{ position: 'relative' }}
            onMouseEnter={() => setSupportMenuOpen(true)}
            onMouseLeave={() => setSupportMenuOpen(false)}>
            <button onClick={() => setSupportMenuOpen(v => !v)}
              title="Contact Support"
              aria-expanded={supportMenuOpen}
              style={{
                width: '36px', height: '36px', borderRadius: '50%', border: 'none',
                background: 'linear-gradient(135deg, #16a34a, #15803d)',
                boxShadow: supportMenuOpen ? '0 4px 14px rgba(21,128,61,0.45)' : '0 2px 8px rgba(21,128,61,0.35)',
                cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'transform 0.2s, box-shadow 0.2s',
                transform: supportMenuOpen ? 'scale(1.1)' : 'scale(1)',
              }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </button>
            {supportMenuOpen && (
              <div style={{
                position: 'absolute', right: 0, top: '2.6rem', width: '230px',
                background: '#fff', borderRadius: '10px', border: '1px solid #e5e7eb',
                boxShadow: '0 10px 30px rgba(0,0,0,0.15)', zIndex: 60, padding: '0.85rem 1rem',
              }}>
                <div style={{ fontSize: '0.66rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '0.3rem' }}>
                  For Support
                </div>
                <a href="tel:+914461556522" style={{ display: 'block', fontSize: '0.95rem', fontWeight: 700, color: '#15803d', textDecoration: 'none', marginBottom: '0.65rem' }}>
                  +91 (0) 44 6155 6522
                </a>
                <div style={{ height: 1, background: '#f3f4f6', margin: '0 0 0.6rem' }} />
                <div style={{ fontSize: '0.66rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.6px', marginBottom: '0.35rem' }}>
                  Business Hours
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.75rem', fontSize: '0.76rem', color: '#6b7280', marginBottom: '0.15rem' }}>
                  <span>Monday – Friday</span>
                  <span style={{ fontWeight: 600, color: '#374151' }}>9 AM – 6:30 PM</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.75rem', fontSize: '0.76rem', color: '#6b7280' }}>
                  <span>Saturday</span>
                  <span style={{ fontWeight: 600, color: '#374151' }}>10 AM – 6:30 PM</span>
                </div>
              </div>
            )}
          </div>
          </>)}
          </div>

          {!isMobile && propertyClock && (
            <span style={{ ...infoPillStyle, background: '#f0f9ff', borderColor: '#bae6fd', color: '#0369a1', fontWeight: 600, fontSize: '0.72rem', fontFamily: 'monospace', letterSpacing: '0.02em' }}>
              {propertyClock}
            </span>
          )}

          {!isMobile && <div style={{ width: '1px', height: '28px', background: '#e5e7eb' }} />}

          <button onClick={() => setCmdOpen(true)} title="Search screens (Ctrl-K)"
            style={{ display: 'flex', alignItems: 'center', gap: '6px', height: isMobile ? '36px' : '34px', ...(isMobile ? { width: '36px', justifyContent: 'center', flexShrink: 0 } : {}), padding: isMobile ? 0 : '0 10px', borderRadius: '18px', border: '1px solid #e5e7eb', background: '#f9fafb', color: '#64748b', cursor: 'pointer', fontSize: '0.8rem', fontWeight: 500 }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--theme-primary, #0d8f83)'; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = '#e5e7eb'; }}>
            <span style={{ fontSize: '0.95rem' }}>⌕</span>
            {!isMobile && <span>Search</span>}
          </button>

          <CommandPalette open={cmdOpen} items={commandItems} recent={recentScreens} onClose={() => setCmdOpen(false)} onSelect={handleCommandSelect} isMobile={isMobile} />

          <div style={{ position: 'relative' }}>
            <button onClick={() => setAccountMenuOpen((prev) => !prev)} title={username || 'Account'}
              style={{ position: 'relative', width: '36px', height: '36px', flexShrink: 0, borderRadius: '50%', background: 'linear-gradient(135deg, var(--theme-nav-from), var(--theme-nav-to))', color: '#fff', border: '2px solid #fff', boxShadow: '0 2px 6px rgba(0,0,0,0.12)', cursor: 'pointer', fontWeight: 700, fontSize: '0.78rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {(username || '?')[0].toUpperCase()}
              {/* Mobile: Guest Feedback lives in this menu — flag new feedback here */}
              {isMobile && hasFrontOfficeAccess && feedbackCount > 0 && (
                <span style={{ position: 'absolute', top: '-2px', right: '-2px', width: '11px', height: '11px', borderRadius: '50%', background: '#ef4444', border: '2px solid #fff' }} />
              )}
            </button>
            {accountMenuOpen && (
              <div style={{ position: 'absolute', right: 0, top: '2.6rem', minWidth: '200px', background: '#fff', borderRadius: '10px', boxShadow: '0 10px 30px rgba(0,0,0,0.15)', border: '1px solid #e5e7eb', zIndex: 60, overflow: 'hidden' }}>
                <div style={{ padding: '0.7rem 1rem', background: '#f0fdf4', borderBottom: '1px solid #f3f4f6' }}>
                  <div style={{ fontSize: '0.85rem', fontWeight: 700, color: '#166534' }}>{username || '-'}</div>
                  {role && <div style={{ fontSize: '0.72rem', color: '#6b7280', textTransform: 'capitalize', marginTop: '1px' }}>{String(role).replace(/_/g, ' ')}</div>}
                </div>
                {/* Mobile: header shortcuts that don't fit in the one-row header */}
                {isMobile && hasFrontOfficeAccess && (
                  <button onClick={() => { setActiveMenu('front-office'); setScreen('pms-guest-feedback'); setAccountMenuOpen(false); }}
                    style={{ width: '100%', padding: '0.7rem 1rem', textAlign: 'left', background: '#fff', border: 'none', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 500, color: '#374151', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span>{'⭐'}</span>
                    <span style={{ flex: 1 }}>Guest Feedback</span>
                    {feedbackCount > 0 && (
                      <span style={{ background: '#ef4444', color: '#fff', borderRadius: '999px', fontSize: '0.62rem', fontWeight: 700, padding: '1px 7px' }}>{feedbackCount > 99 ? '99+' : feedbackCount}</span>
                    )}
                  </button>
                )}
                {isMobile && (
                  <button onClick={() => { setActiveMenu('hotel-config'); setScreen('faq-assistant'); setAccountMenuOpen(false); }}
                    style={{ width: '100%', padding: '0.7rem 1rem', textAlign: 'left', background: '#fff', border: 'none', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 500, color: '#374151', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span>❓</span><span>FAQ / Help</span>
                  </button>
                )}
                {isMobile && (
                  <div style={{ padding: '0.6rem 1rem', borderBottom: '1px solid #f3f4f6', background: '#fff' }}>
                    <div style={{ fontSize: '0.62rem', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.6px' }}>For Support</div>
                    <a href="tel:+914461556522" style={{ display: 'block', fontSize: '0.88rem', fontWeight: 700, color: '#15803d', textDecoration: 'none', margin: '0.15rem 0' }}>
                      {'📞'} +91 (0) 44 6155 6522
                    </a>
                    <div style={{ fontSize: '0.68rem', color: '#6b7280' }}>Mon–Fri 9 AM – 6:30 PM · Sat 10 AM – 6:30 PM</div>
                  </div>
                )}
                {role === 'admin' && (
                  <button onClick={() => { setScreen('admin-audit-trails'); setActiveMenu('hotel-config'); setAccountMenuOpen(false); }}
                    style={{ width: '100%', padding: '0.7rem 1rem', textAlign: 'left', background: '#fff', border: 'none', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                    Audit Trails
                  </button>
                )}
                {role === 'admin' && (
                  <button onClick={() => { setScreen('admin-error-log'); setActiveMenu('hotel-config'); setAccountMenuOpen(false); }}
                    style={{ width: '100%', padding: '0.7rem 1rem', textAlign: 'left', background: '#fff', border: 'none', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                    Error Log
                  </button>
                )}
                <button onClick={() => { setChangePasswordOpen(true); setAccountMenuOpen(false); }}
                  style={{ width: '100%', padding: '0.7rem 1rem', textAlign: 'left', background: '#fff', border: 'none', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 500, color: '#374151' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                  Change Password
                </button>
                {!isMobile && (
                  <button onClick={() => {
                      const next = navMode === 'sidebar' ? 'topbar' : 'sidebar';
                      setNavMode(next); setRailFlyout(null);
                      try { localStorage.setItem('easepms_nav_mode', next); } catch { /* ignore */ }
                      setAccountMenuOpen(false);
                    }}
                    style={{ width: '100%', padding: '0.7rem 1rem', textAlign: 'left', background: '#fff', border: 'none', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 500, color: '#374151', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.5rem' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                    <span>◧ Left Sidebar <span style={{ fontSize: '0.6rem', color: '#0d8f83', fontWeight: 700 }}>BETA</span></span>
                    <span style={{ fontSize: '0.66rem', fontWeight: 700, color: navMode === 'sidebar' ? '#166534' : '#94a3b8', background: navMode === 'sidebar' ? '#dcfce7' : '#f1f5f9', borderRadius: 20, padding: '2px 8px' }}>{navMode === 'sidebar' ? 'ON' : 'OFF'}</span>
                  </button>
                )}
                <button onClick={async () => {
                    setAccountMenuOpen(false);
                    try {
                      const res = await fetch('/api/v1/cross-auth/launch', {
                        method: 'POST',
                        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
                      });
                      const data = await res.json().catch(() => ({}));
                      if (!res.ok) {
                        window.alert(data.error || 'Failed to launch Channel Manager. Please try again or contact support.');
                        return;
                      }
                      if (data.launch_url) {
                        window.open(data.launch_url, '_blank');
                      } else {
                        window.alert('Channel Manager did not return a launch URL.');
                      }
                    } catch { window.alert('Network error — could not reach Channel Manager.'); }
                  }}
                  style={{ width: '100%', padding: '0.7rem 1rem', textAlign: 'left', background: '#fff', border: 'none', borderBottom: '1px solid #f3f4f6', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 500, color: '#1e40af' }}
                  onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                  Switch to Channel Manager
                </button>
                <button onClick={performLogout}
                  style={{ width: '100%', padding: '0.7rem 1rem', textAlign: 'left', background: '#fff', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600 }}
                  onMouseEnter={e => e.currentTarget.style.background = '#fef2f2'} onMouseLeave={e => e.currentTarget.style.background = '#fff'}>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </header>

      {changePasswordOpen && <ChangePasswordModal token={token} onClose={() => setChangePasswordOpen(false)} />}

      {/* ── BLUE NAVIGATION BAR WITH DROPDOWNS ── */}
      {/* ── PHASE 3: LEFT MODULE RAIL (opt-in "sidebar" nav mode) ── */}
      {sidebarOn && (
        <>
          <div style={{ position: 'fixed', left: 0, top: 0, bottom: 0, width: RAIL_W, background: 'linear-gradient(180deg, var(--theme-nav-from), var(--theme-nav-to))', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', padding: '8px 0 10px', zIndex: 60, overflowY: 'auto' }}
            onMouseLeave={() => { clearTimeout(railTimerRef.current); railTimerRef.current = setTimeout(() => setRailFlyout(null), 280); }}
            onMouseEnter={() => clearTimeout(railTimerRef.current)}>
            <div style={{ width: 34, height: 34, borderRadius: 9, background: 'rgba(255,255,255,0.16)', color: '#fff', display: 'grid', placeItems: 'center', fontWeight: 800, fontSize: '0.9rem', marginBottom: '8px', flexShrink: 0 }}>E</div>
            {paletteModuleDefs.filter(m => m.show).map(m => {
              const active = activeMenu === m.key;
              return (
                <button key={m.key} title={m.label}
                  onMouseEnter={(e) => { clearTimeout(railTimerRef.current); anchorRailFlyout(e); setRailFlyout(m.key); }}
                  onClick={(e) => { anchorRailFlyout(e); setRailFlyout(prev => (prev === m.key ? null : m.key)); }}
                  style={{ width: 44, height: 44, borderRadius: 10, border: 'none', cursor: 'pointer', flexShrink: 0, display: 'grid', placeItems: 'center', background: active ? 'rgba(255,255,255,0.92)' : (railFlyout === m.key ? 'rgba(255,255,255,0.18)' : 'transparent'), boxShadow: active ? '0 2px 8px rgba(0,0,0,0.2)' : 'none' }}>
                  <ModuleIcon id={m.key} size={21} strokeWidth={1.7} color={active ? '#1e3a5f' : '#fff'} />
                </button>
              );
            })}
            <button title="Search screens (Ctrl-K)" onClick={() => setCmdOpen(true)}
              style={{ marginTop: 'auto', width: 44, height: 40, borderRadius: 10, border: 'none', background: 'transparent', color: '#fff', cursor: 'pointer', fontSize: '1.15rem', flexShrink: 0 }}>⌕</button>
          </div>
          {railFlyout && (() => {
            const m = paletteModuleDefs.find(x => x.key === railFlyout);
            const items = (menuMap[railFlyout] || []).filter(item => canAccessItem(item, railFlyout));
            if (!m || !items.length) return null;
            const groups = groupSubItems(items, railFlyout);
            const grp = { fontSize: '10px', fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#94a3b8', padding: '9px 10px 3px' };
            return (
              <div style={{ position: 'fixed', left: RAIL_W + 4, top: railFlyoutTop, width: 262, maxHeight: `calc(100vh - ${railFlyoutTop + 16}px)`, overflowY: 'auto', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 18px 44px rgba(15,35,58,0.2)', padding: '10px 8px 12px', zIndex: 61 }}
                onMouseEnter={() => clearTimeout(railTimerRef.current)}
                onMouseLeave={() => { railTimerRef.current = setTimeout(() => setRailFlyout(null), 280); }}>
                <div style={{ fontWeight: 700, color: 'var(--theme-primary-dark, #1e3a5f)', fontSize: '0.95rem', padding: '2px 10px 8px' }}>{m.label}</div>
                {groups.map((g, gi) => (
                  <div key={gi}>
                    {g.label && <div style={grp}>{g.label}</div>}
                    {g.items.map(item => {
                      const active = screen === item.key && activeMenu === railFlyout;
                      return (
                        <button key={item.key}
                          onClick={() => {
                            setActiveMenu(railFlyout);
                            if (railFlyout === 'food-inventory') { const sec = Object.keys(foodSectionMap).find(s => (foodSectionMap[s] || []).includes(item.key)); if (sec) setFoodSection(sec); }
                            setScreen(item.key); setRailFlyout(null);
                          }}
                          style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '9px', textAlign: 'left', border: 'none', background: active ? '#eff6ff' : 'transparent', color: active ? '#1e40af' : '#374151', fontWeight: active ? 700 : 500, fontSize: '0.83rem', padding: '7px 10px', borderRadius: 8, cursor: 'pointer' }}
                          onMouseEnter={e => { if (!active) e.currentTarget.style.background = '#f9fafb'; }}
                          onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}>
                          <span style={{ width: 5, height: 5, borderRadius: '50%', background: active ? '#1e40af' : '#d1d5db', flexShrink: 0 }} />
                          {item.label}
                        </button>
                      );
                    })}
                  </div>
                ))}
              </div>
            );
          })()}
        </>
      )}

      <nav style={navBarStyle}>
        {navCanScrollLeft && (
          <button style={navScrollArrowStyle} onClick={() => { navScrollRef.current?.scrollBy({ left: -200, behavior: 'smooth' }); }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.3)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,0,0,0.18)'}
            title="Scroll left">{'\u00AB'}</button>
        )}
        <div ref={navScrollRef} className="nav-scroll-container" onMouseLeave={() => handleMenuLeave()} style={{ display: 'flex', alignItems: 'center', gap: '0.15rem', flex: 1, overflowX: 'auto', overflowY: 'hidden', height: '100%', padding: '0 0.5rem', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
        {(() => {
          const filterSubItems = (items, menuKey) => (items || []).filter(item => {
            if (!portalAllowsItem(item, menuKey)) return false;
            if (item.key === 'pms-policy-config') return role === 'admin' || String(role || '').toLowerCase() === 'hotel_admin' || Boolean(permissions?.hotel_admin) || hasFrontOfficePermission;
            if (item.adminOnly && role !== 'admin' && String(role || '').toLowerCase() !== 'hotel_admin' && !permissions?.hotel_admin) return false;
            if (!item.permission) return true;
            if (item.permission === 'bar') return hasBarAccess;
            if (item.permission === 'kot') return hasKotAccess;
            if (item.permission === 'banquet') return hasBanquetCoreAccess;
            if (item.permission === 'banquet_crm') return hasBanquetCrmAccess;
            if (item.permission === 'front_office') return hasFrontOfficeAccess;
            if (item.permission === 'housekeeping') return hasHousekeepingAccess;
            if (item.permission === 'maintenance') return hasMaintenanceAccess;
            if (item.permission === 'stores') return hasStoresAccess;
            if (item.permission === 'expenses')        return hasExpenseAccess;
            if (item.permission === 'expense_approve') return hasExpenseApproveAccess;
            if (item.permission === 'expense_admin')   return hasExpenseAdminAccess;
            if (item.permission === 'petty_cash')      return hasPettyCashAccess;
            if (item.permission === 'revenue_dashboard') return hasRevenueDashboardAccess;
            return hasPermission(item.permission);
          });

          const mainMenus = [
            { key: 'hotel-config', label: 'Hotel Config', icon: '\u2699', onClick: () => { setActiveMenu('hotel-config'); setScreen('property-selector'); }, show: true },
            { key: 'front-office', label: 'Front Office', icon: '\ud83c\udfe8', onClick: openFrontOffice, show: hasFrontOfficeAccess && inWorkspace },
            { key: 'kot', label: 'KOT & POS', icon: '\ud83c\udf7d', onClick: openKot, show: hasKotAccess && inWorkspace },
            { key: 'food-inventory', label: 'Food Inventory', icon: '\ud83d\udce6', onClick: openFoodInventory, show: hasFoodInventoryAccess && inWorkspace },
            { key: 'banquet', label: 'Banquet', icon: '\ud83c\udf89', onClick: openBanquet, show: hasBanquetAccess && inWorkspace },
            { key: 'housekeeping', label: 'Housekeeping', icon: '\ud83e\uddf9', onClick: openHousekeeping, show: hasHousekeepingAccess && inWorkspace },
            { key: 'engineering', label: 'Engineering', icon: '\ud83d\udd27', onClick: openEngineering, show: hasMaintenanceAccess && inWorkspace },
            { key: 'stores', label: 'Stores', icon: '\ud83c\udfec', onClick: openStores, show: hasStoresAccess && inWorkspace },
            { key: 'ai-functions', label: 'AI Functions', icon: '\ud83e\udd16', onClick: () => { setActiveMenu('ai-functions'); setScreen((menuMap['ai-functions'] || [])[0]?.key || 'pms-guest-recognition'); }, show: hasAiFunctionsAccess && inWorkspace && (menuMap['ai-functions'] || []).length > 0 },
            { key: 'bar-management', label: 'Bar Mgmt', icon: '\ud83c\udf7a', onClick: openBarManagement, show: hasBarAccess && inWorkspace },
            { key: 'accounting', label: 'Accounting', icon: '\ud83d\udcb0', onClick: openAccounting, show: hasAccountingAccess && inWorkspace },
            { key: 'expense', label: 'Expense & Profitability', icon: '\ud83d\udcb8', onClick: openExpense, show: (hasExpenseAccess || hasRevenueDashboardAccess) && inWorkspace },
            { key: 'subscription', label: 'Subscription', icon: '\ud83d\udcb3', onClick: () => { setModuleAccessError(''); setActiveMenu('subscription'); setScreen('sub-dashboard'); }, show: inConsole },
            { key: 'platform-reports', label: 'Reports', icon: '\ud83d\udcca', onClick: () => { setModuleAccessError(''); setActiveMenu('platform-reports'); setScreen('user-login-activity'); }, show: inConsole },
            { key: 'settings', label: 'Settings', icon: '\ud83d\udd27', onClick: () => { setModuleAccessError(''); setActiveMenu('settings'); setScreen('channel-manager-settings'); }, show: inConsole }
          ];

          return mainMenus.filter(m => m.show).map(menu => {
            const subItems = filterSubItems(menuMap[menu.key], menu.key);
            const isActive = activeMenu === menu.key;
            const isHovered = hoveredMenu === menu.key;
            const hasDropdown = subItems.length > 0 && menu.key !== 'food-inventory';

            return (
              <div key={menu.key} style={{ height: '100%', display: 'flex', alignItems: 'center', flexShrink: 0 }}
                onMouseEnter={e => hasDropdown ? handleMenuEnter(menu.key, e) : setHoveredMenu(null)}>
                <button onClick={() => { menu.onClick(); setHoveredMenu(null); }}
                  style={isActive ? navItemActiveStyle : isHovered ? navItemHoverStyle : navItemStyle}>
                  <span style={{ fontSize: '1rem' }}>{menu.icon}</span>
                  {menu.label}
                  {hasDropdown && <span style={{ fontSize: '0.55rem', opacity: 0.7 }}>{'\u25BC'}</span>}
                </button>
              </div>
            );
          });
        })()}
        </div>
        {navCanScrollRight && (
          <button style={navScrollArrowStyle} onClick={() => { navScrollRef.current?.scrollBy({ left: 200, behavior: 'smooth' }); }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,0,0,0.3)'}
            onMouseLeave={e => e.currentTarget.style.background = 'rgba(0,0,0,0.18)'}
            title="Scroll right">{'\u00BB'}</button>
        )}
      </nav>

      {/* ── DROPDOWN MENU (rendered outside scroll container) ── */}
      {hoveredMenu && !isMobile && (() => {
        const filterSubItems = (items, menuKey) => (items || []).filter(item => {
          if (!portalAllowsItem(item, menuKey)) return false;
          if (item.key === 'pms-policy-config') return role === 'admin' || String(role || '').toLowerCase() === 'hotel_admin' || Boolean(permissions?.hotel_admin) || hasFrontOfficePermission;
          if (item.adminOnly && role !== 'admin' && String(role || '').toLowerCase() !== 'hotel_admin' && !permissions?.hotel_admin) return false;
          if (!item.permission) return true;
          if (item.permission === 'bar') return hasBarAccess;
          if (item.permission === 'kot') return hasKotAccess;
          if (item.permission === 'banquet') return hasBanquetCoreAccess;
          if (item.permission === 'banquet_crm') return hasBanquetCrmAccess;
          if (item.permission === 'front_office') return hasFrontOfficeAccess;
          if (item.permission === 'housekeeping') return hasHousekeepingAccess;
          if (item.permission === 'maintenance') return hasMaintenanceAccess;
          if (item.permission === 'stores') return hasStoresAccess;
          if (item.permission === 'expenses')        return hasExpenseAccess;
          if (item.permission === 'expense_approve') return hasExpenseApproveAccess;
          if (item.permission === 'expense_admin')   return hasExpenseAdminAccess;
          if (item.permission === 'petty_cash')      return hasPettyCashAccess;
          if (item.permission === 'revenue_dashboard') return hasRevenueDashboardAccess;
          return hasPermission(item.permission);
        });
        const subItems = filterSubItems(menuMap[hoveredMenu], hoveredMenu);
        if (subItems.length === 0 || hoveredMenu === 'food-inventory') return null;
        const groups = groupSubItems(subItems, hoveredMenu);
        const isMega = groups.length >= 3 && subItems.length >= 8;
        const grpLabelStyle = { fontSize: '10px', fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#94a3b8', padding: '9px 10px 3px' };
        const renderItem = (item) => {
          const badgeCount = item.key === 'pms-guest-requests' ? (requestBadgeCounts.hkOpen + requestBadgeCounts.svcOpen) :
                             item.key === 'pms-housekeeping' ? requestBadgeCounts.hkOpen : 0;
          const active = screen === item.key && activeMenu === hoveredMenu;
          return (
            <button key={item.key} onClick={() => { setActiveMenu(hoveredMenu); setScreen(item.key); setHoveredMenu(null); }}
              style={{ ...dropdownItemStyle, ...(active ? { background: '#eff6ff', color: '#1e40af', fontWeight: 700 } : {}) }}
              onMouseEnter={e => { if (!active) e.currentTarget.style.background = '#f9fafb'; }}
              onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent'; }}>
              <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: active ? '#1e40af' : '#d1d5db', flexShrink: 0 }} />
              {item.label}
              {badgeCount > 0 && (
                <span style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: '#ef4444', color: '#fff', borderRadius: '999px', minWidth: '18px', height: '18px', fontSize: '0.62rem', fontWeight: 700, padding: '0 0.3rem' }}>
                  {badgeCount}
                </span>
              )}
            </button>
          );
        };
        if (isMega) {
          const panelW = 820;
          const vw = (typeof window !== 'undefined' && window.innerWidth) || 1280;
          const left = Math.max(12, Math.min(dropdownPos.left, vw - panelW - 14));
          return (
            <div style={{ position: 'fixed', top: dropdownPos.top, left, width: 'min(820px, 94vw)', maxHeight: '78vh', overflowY: 'auto', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', boxShadow: '0 18px 44px rgba(15,35,58,0.18)', padding: '12px 16px 16px', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(188px, 1fr))', gap: '2px 20px', alignItems: 'start', zIndex: 1200 }}
              onMouseEnter={() => clearTimeout(hoverTimeoutRef.current)}
              onMouseLeave={() => handleMenuLeave()}>
              {groups.map((g, gi) => (
                <div key={gi} style={{ marginBottom: '6px' }}>
                  {g.label && <div style={grpLabelStyle}>{g.label}</div>}
                  {g.items.map(renderItem)}
                </div>
              ))}
            </div>
          );
        }
        return (
          <div style={{ ...dropdownStyle, position: 'fixed', top: dropdownPos.top, left: dropdownPos.left }}
            onMouseEnter={() => clearTimeout(hoverTimeoutRef.current)}
            onMouseLeave={() => handleMenuLeave()}>
            {groups.map((g, gi) => (
              <div key={gi}>
                {g.label && <div style={grpLabelStyle}>{g.label}</div>}
                {g.items.map(renderItem)}
              </div>
            ))}
          </div>
        );
      })()}

      {isMobile && backToast && (
        <div role="status" style={{ position: 'fixed', left: '50%', bottom: 'calc(24px + env(safe-area-inset-bottom, 0px))', transform: 'translateX(-50%)', background: 'rgba(17,24,39,0.92)', color: '#fff', fontSize: '0.8rem', padding: '8px 14px', borderRadius: '999px', zIndex: 3000, whiteSpace: 'nowrap', pointerEvents: 'none' }}>
          {backToast}
        </div>
      )}

      {/* ── MOBILE NAV DRAWER ── */}
      {isMobile && (
        <>
          {mobileNavOpen && <div className="mobile-nav-overlay open" onClick={() => setMobileNavOpen(false)} />}
          <div className={`mobile-nav-drawer${mobileNavOpen ? ' open' : ''}`}>
            {/* Drawer header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.75rem 1rem', borderBottom: '1px solid #e5e7eb', background: 'linear-gradient(135deg, var(--theme-nav-from), var(--theme-nav-to))' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {selectedProperty?.logo_url ? (
                  <img src={selectedProperty.logo_url} alt="Logo" style={{ width: '32px', height: '32px', borderRadius: '6px', objectFit: 'cover', border: '1px solid rgba(255,255,255,0.3)' }} />
                ) : (
                  <div style={{ width: '32px', height: '32px', borderRadius: '6px', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: '0.8rem' }}>E</div>
                )}
                <div>
                  <div style={{ fontWeight: 700, fontSize: '0.85rem', color: '#fff' }}>EASEPMS</div>
                  <div style={{ fontSize: '0.6rem', color: 'rgba(255,255,255,0.7)' }}>Hospitality Experience Management</div>
                </div>
              </div>
              <button onClick={() => setMobileNavOpen(false)}
                style={{ width: '32px', height: '32px', borderRadius: '6px', background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', fontSize: '1.2rem', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                ✕
              </button>
            </div>

            {/* Property + Outlet info */}
            <div style={{ padding: '0.75rem 1rem', borderBottom: '1px solid #f3f4f6', background: '#f9fafb' }}>
              {role === 'admin' && portalMode === 'workspace' && (
                <button onClick={() => { backToPlatformConsole(); setMobileNavOpen(false); }}
                  style={{ width: '100%', marginBottom: '0.6rem', padding: '0.5rem', borderRadius: '8px', border: '1px solid #c7d2fe', background: '#eef2ff', color: '#4338ca', fontWeight: 600, fontSize: '0.8rem', cursor: 'pointer' }}>
                  &larr; Back to Platform Console
                </button>
              )}
              <div style={{ fontSize: '0.7rem', fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.3rem' }}>{inConsole ? 'Portal' : 'Property'}</div>
              <div style={{ fontSize: '0.82rem', fontWeight: 600, color: inConsole ? '#4338ca' : (selectedProperty ? '#1e40af' : '#991b1b') }}>
                {inConsole ? 'Platform Console' : (selectedProperty ? `${selectedProperty.code} — ${selectedProperty.name}` : 'No Property')}
              </div>
              {kotOutlets.length > 0 && (
                <div style={{ marginTop: '0.5rem' }}>
                  <div style={{ fontSize: '0.7rem', fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.2rem' }}>Outlet</div>
                  <select value={selectedKotOutletId}
                    onChange={(e) => {
                      const nextId = String(e.target.value || '');
                      setSelectedKotOutletId(nextId);
                      if (nextId) setModuleAccessError('');
                      if (selectedProperty?.id) {
                        const key = `selectedKotOutletId:${selectedProperty.id}`;
                        if (nextId) localStorage.setItem(key, nextId);
                        else localStorage.removeItem(key);
                      }
                    }}
                    style={{ width: '100%', padding: '0.4rem 0.5rem', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff', fontSize: '0.8rem', fontWeight: 500 }}>
                    <option value="">Select Outlet</option>
                    {kotOutlets.map((o) => <option key={o.id} value={o.id}>{o.code ? `${o.code} - ${o.name}` : (o.name || o.id)}</option>)}
                  </select>
                </div>
              )}
              <div style={{ marginTop: '0.4rem', fontSize: '0.78rem', color: '#166534', fontWeight: 600 }}>
                {username || '-'}
              </div>
            </div>

            {/* Menu items */}
            <div style={{ overflowY: 'auto', flex: 1 }}>
              {(() => {
                // Mobile drawer only — Night Audit is a desktop task.
                const MOBILE_HIDDEN_ITEMS = new Set(['pms-night-audit']);
                const filterSubItems = (items, menuKey) => (items || []).filter(item => {
                  if (MOBILE_HIDDEN_ITEMS.has(item.key)) return false;
                  if (!portalAllowsItem(item, menuKey)) return false;
                  if (item.key === 'pms-policy-config') return role === 'admin' || String(role || '').toLowerCase() === 'hotel_admin' || Boolean(permissions?.hotel_admin) || hasFrontOfficePermission;
                  if (item.adminOnly && role !== 'admin' && String(role || '').toLowerCase() !== 'hotel_admin' && !permissions?.hotel_admin) return false;
                  if (!item.permission) return true;
                  if (item.permission === 'bar') return hasBarAccess;
                  if (item.permission === 'kot') return hasKotAccess;
                  if (item.permission === 'banquet') return hasBanquetCoreAccess;
                  if (item.permission === 'banquet_crm') return hasBanquetCrmAccess;
                  if (item.permission === 'front_office') return hasFrontOfficeAccess;
                  if (item.permission === 'housekeeping') return hasHousekeepingAccess;
                  if (item.permission === 'maintenance') return hasMaintenanceAccess;
                  if (item.permission === 'stores') return hasStoresAccess;
                  if (item.permission === 'expenses')        return hasExpenseAccess;
                  if (item.permission === 'expense_approve') return hasExpenseApproveAccess;
                  if (item.permission === 'expense_admin')   return hasExpenseAdminAccess;
                  if (item.permission === 'petty_cash')      return hasPettyCashAccess;
                  return hasPermission(item.permission);
                });

                const mobileMenus = [
                  // Hotel Config is hidden in the mobile drawer (desktop only).
                  { key: 'hotel-config', label: 'Hotel Config', icon: '\u2699', onClick: () => { setActiveMenu('hotel-config'); setScreen('property-selector'); }, show: false },
                  { key: 'front-office', label: 'Front Office', icon: '\ud83c\udfe8', onClick: openFrontOffice, show: hasFrontOfficeAccess && inWorkspace },
                  { key: 'kot', label: 'KOT & POS', icon: '\ud83c\udf7d', onClick: openKot, show: hasKotAccess && inWorkspace },
                  { key: 'food-inventory', label: 'Food Inventory', icon: '\ud83d\udce6', onClick: openFoodInventory, show: hasFoodInventoryAccess && inWorkspace },
                  { key: 'banquet', label: 'Banquet', icon: '\ud83c\udf89', onClick: openBanquet, show: hasBanquetAccess && inWorkspace },
                  { key: 'housekeeping', label: 'Housekeeping', icon: '\ud83e\uddf9', onClick: openHousekeeping, show: hasHousekeepingAccess && inWorkspace },
                  { key: 'engineering', label: 'Engineering', icon: '\ud83d\udd27', onClick: openEngineering, show: hasMaintenanceAccess && inWorkspace },
                  { key: 'stores', label: 'Stores', icon: '\ud83c\udfec', onClick: openStores, show: hasStoresAccess && inWorkspace },
                  { key: 'ai-functions', label: 'AI Functions', icon: '\ud83e\udd16', onClick: () => { setActiveMenu('ai-functions'); setScreen((menuMap['ai-functions'] || [])[0]?.key || 'pms-guest-recognition'); }, show: hasAiFunctionsAccess && inWorkspace && (menuMap['ai-functions'] || []).length > 0 },
                  { key: 'bar-management', label: 'Bar Mgmt', icon: '\ud83c\udf7a', onClick: openBarManagement, show: hasBarAccess && inWorkspace },
                  { key: 'accounting', label: 'Accounting', icon: '\ud83d\udcb0', onClick: openAccounting, show: hasAccountingAccess && inWorkspace },
                  { key: 'expense', label: 'Expense & Profitability', icon: '\ud83d\udcb8', onClick: openExpense, show: (hasExpenseAccess || hasRevenueDashboardAccess) && inWorkspace },
                  { key: 'subscription', label: 'Subscription', icon: '\ud83d\udcb3', onClick: () => { setModuleAccessError(''); setActiveMenu('subscription'); setScreen('sub-dashboard'); }, show: inConsole },
                  { key: 'platform-reports', label: 'Reports', icon: '\ud83d\udcca', onClick: () => { setModuleAccessError(''); setActiveMenu('platform-reports'); setScreen('user-login-activity'); }, show: inConsole },
                  { key: 'settings', label: 'Settings', icon: '\ud83d\udd27', onClick: () => { setModuleAccessError(''); setActiveMenu('settings'); setScreen('channel-manager-settings'); }, show: inConsole }
                ];

                return mobileMenus.filter(m => m.show).map(menu => {
                  const subItems = filterSubItems(menuMap[menu.key], menu.key);
                  const isActive = activeMenu === menu.key;
                  const expanded = mobileExpandedMenu === menu.key;

                  return (
                    <div key={menu.key} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      <button
                        onClick={() => {
                          if (subItems.length > 0) {
                            setMobileExpandedMenu(prev => prev === menu.key ? null : menu.key);
                          } else {
                            menu.onClick();
                            setMobileNavOpen(false);
                          }
                        }}
                        style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '0.6rem', padding: '0.75rem 1rem', background: isActive ? '#eff6ff' : '#fff', border: 'none', cursor: 'pointer', textAlign: 'left', fontSize: '0.88rem', fontWeight: isActive ? 700 : 500, color: isActive ? '#1e40af' : '#374151' }}>
                        <span style={{ fontSize: '1.1rem', width: '24px', textAlign: 'center' }}>{menu.icon}</span>
                        <span style={{ flex: 1 }}>{menu.label}</span>
                        {subItems.length > 0 && (
                          <span style={{ fontSize: '0.6rem', color: '#9ca3af', transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>{'\u25BC'}</span>
                        )}
                      </button>

                      {subItems.length > 0 && expanded && (
                        <div style={{ background: '#f9fafb', paddingBottom: '0.25rem' }}>
                          {groupSubItems(subItems, menu.key).map((g, gi) => (
                            <div key={gi}>
                              {g.label && (
                                <div style={{ fontSize: '9.5px', fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#9ca3af', padding: '0.55rem 1rem 0.15rem 2.8rem' }}>{g.label}</div>
                              )}
                              {g.items.map(item => {
                                const isItemActive = screen === item.key && activeMenu === menu.key;
                                const badgeCount = item.key === 'pms-guest-requests' ? (requestBadgeCounts.hkOpen + requestBadgeCounts.svcOpen) :
                                                   item.key === 'pms-housekeeping' ? requestBadgeCounts.hkOpen : 0;
                                return (
                                  <button key={item.key}
                                    onClick={() => { setActiveMenu(menu.key); setScreen(item.key); setMobileNavOpen(false); }}
                                    style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.55rem 1rem 0.55rem 2.8rem', background: isItemActive ? '#dbeafe' : 'transparent', border: 'none', cursor: 'pointer', textAlign: 'left', fontSize: '0.82rem', fontWeight: isItemActive ? 700 : 500, color: isItemActive ? '#1e40af' : '#4b5563' }}>
                                    <span style={{ width: '4px', height: '4px', borderRadius: '50%', background: isItemActive ? '#1e40af' : '#d1d5db', flexShrink: 0 }} />
                                    <span style={{ flex: 1 }}>{item.label}</span>
                                    {badgeCount > 0 && (
                                      <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: '#ef4444', color: '#fff', borderRadius: '999px', minWidth: '18px', height: '18px', fontSize: '0.62rem', fontWeight: 700, padding: '0 0.3rem' }}>
                                        {badgeCount}
                                      </span>
                                    )}
                                  </button>
                                );
                              })}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                });
              })()}
            </div>

            {/* Drawer footer — Logout */}
            <div style={{ padding: '0.75rem 1rem', borderTop: '1px solid #e5e7eb', background: '#f9fafb' }}>
              <button onClick={() => { setMobileNavOpen(false); performLogout(); }}
                style={{ width: '100%', padding: '0.6rem', borderRadius: '8px', background: '#fef2f2', border: '1px solid #fecaca', color: '#dc2626', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer', textAlign: 'center' }}>
                Logout
              </button>
            </div>
          </div>
        </>
      )}

      {/* ── SUB-NAV (only for food-inventory which has 2-level tabs) ── */}
      {activeMenu === 'food-inventory' && (
        <>
          <div style={subNavStyle}>
            {foodSectionTabs.map((sectionKey) => (
              <button key={sectionKey}
                onClick={() => { setFoodSection(sectionKey); const first = (foodSectionMap[sectionKey] || []).find((key) => canAccessFoodScreen(key)); if (first) setScreen(first); }}
                style={foodSection === sectionKey ? activeTabStyle : tabStyle}>
                {foodSectionLabels[sectionKey]}
              </button>
            ))}
          </div>
          <div style={subNavStyle}>
            {foodSectionItems.map(item => (
              <button key={item.key} onClick={() => setScreen(item.key)} style={screen === item.key ? activeTabStyle : tabStyle}>
                {item.label}
              </button>
            ))}
          </div>
        </>
      )}

      {/* ── BREADCRUMB ── */}
      {/* Hidden on mobile — the header already shows the location. */}
      {!isMobile && ((breadcrumbParts.length > 0 || screen === 'module-home') && screen !== 'property-selector') && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.75rem', padding: '0.5rem 1.2rem', background: '#f9fafb', borderBottom: '1px solid #f3f4f6' }}>
          {(() => { const parts = screen === 'module-home' ? ['Hotel Config', 'Modules'] : breadcrumbParts; return parts.map((part, i) => (
            <React.Fragment key={i}>
              {i > 0 && <span style={{ color: '#cbd5e0' }}>{'\u203A'}</span>}
              <span style={{ color: i === parts.length - 1 ? 'var(--theme-primary-dark)' : '#6b7280', fontWeight: i === parts.length - 1 ? 600 : 500 }}>{part}</span>
            </React.Fragment>
          )); })()}
        </div>
      )}

      {moduleAccessError && <div style={{ color: '#e84118', padding: '0.8rem 1rem' }}>{moduleAccessError}</div>}

      {screen === 'property-selector' && (() => {
        const searchQuery = propertySearchQuery.trim().toLowerCase();
        const matchesSearch = (p) => !searchQuery
          || String(p.name || '').toLowerCase().includes(searchQuery)
          || String(p.code || '').toLowerCase().includes(searchQuery)
          || String(p.chain_name || '').toLowerCase().includes(searchQuery);
        const searchedActive = accessibleProperties.filter(matchesSearch);
        const inactiveProps = allPropertiesRaw.filter((p) => p.is_active === false).filter(matchesSearch);
        const chainGroups = [];
        const chainIndex = new Map();
        searchedActive.forEach((p) => {
          const key = String(p.chain_id || 'none');
          if (!chainIndex.has(key)) {
            const group = { key, label: p.chain_name || p.chain_code || 'Other Properties', items: [] };
            chainIndex.set(key, group);
            chainGroups.push(group);
          }
          chainIndex.get(key).items.push(p);
        });
        const showChainGroups = chainGroups.length > 1;
        const totalMatches = searchedActive.length + inactiveProps.length;
        const gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '0.85rem' };
        const groupLabelStyle = { fontSize: '0.78rem', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.5rem' };

        const renderCard = (p, opts = {}) => {
          const isSelected = String(selectedPropertyId) === String(p.id);
          const stats = propertyQuickStats[String(p.id)];
          const inactive = Boolean(opts.inactive);
          return (
            <div
              key={p.id}
              className={inactive ? undefined : 'property-card'}
              onClick={() => {
                if (inactive) return;
                setSelectedPropertyId(String(p.id));
                localStorage.setItem('selectedPropertyId', String(p.id));
                setSelectedKotOutletId('');
                setKotOutlets([]);
                setModuleAccessError('');
              }}
              style={{
                border: isSelected ? '2px solid var(--theme-primary-dark)' : '1px solid var(--theme-border)',
                borderRadius: '12px',
                padding: '1rem 1.1rem',
                cursor: inactive ? 'default' : 'pointer',
                background: isSelected ? '#eff3ff' : '#fff',
                opacity: inactive ? 0.55 : 1,
                boxShadow: isSelected ? '0 0 0 3px #c7d2fe' : '0 1px 3px rgba(0,0,0,0.06)',
                display: 'flex', flexDirection: 'column', gap: '0.55rem'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                {p.logo_url ? (
                  <img src={p.logo_url} alt="" style={{ width: 40, height: 40, borderRadius: 8, objectFit: 'cover', border: '1px solid #e5e7eb', flexShrink: 0 }} />
                ) : (
                  <div style={{ width: 40, height: 40, borderRadius: 8, background: 'var(--theme-primary-dark)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1rem', flexShrink: 0 }}>
                    {(p.name || '?').trim().charAt(0).toUpperCase()}
                  </div>
                )}
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: '0.72rem', color: '#6b7280', letterSpacing: '0.06em', textTransform: 'uppercase' }}>{p.code}</div>
                  <div style={{ fontWeight: 600, color: isSelected ? 'var(--theme-primary-dark)' : '#1f2937', fontSize: '0.95rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={p.name}>{p.name}</div>
                </div>
              </div>

              {inactive ? (
                <span style={{ fontSize: '0.68rem', fontWeight: 600, padding: '2px 7px', borderRadius: 999, background: '#fef2f2', color: '#991b1b', alignSelf: 'flex-start' }}>Inactive</span>
              ) : stats ? (
                <div style={{ display: 'flex', gap: '0.35rem', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: '0.68rem', fontWeight: 600, padding: '2px 7px', borderRadius: 999, background: '#ecfdf5', color: '#047857' }}>{stats.occupancy_percent}% occ</span>
                  <span style={{ fontSize: '0.68rem', fontWeight: 600, padding: '2px 7px', borderRadius: 999, background: '#eff6ff', color: '#1d4ed8' }}>{stats.arrivals_today} arriving</span>
                  <span style={{ fontSize: '0.68rem', fontWeight: 600, padding: '2px 7px', borderRadius: 999, background: '#f5f3ff', color: '#6d28d9' }}>{stats.total_rooms} rooms</span>
                </div>
              ) : null}

              <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }} onClick={(e) => e.stopPropagation()}>
                <code style={{ fontSize: '0.7rem', color: '#64748b', background: '#f1f5f9', padding: '2px 6px', borderRadius: 4, fontFamily: 'monospace' }} title={String(p.id)}>
                  {String(p.id).slice(0, 8)}…
                </code>
                <button type="button" onClick={(e) => { e.stopPropagation(); copyPropertyId(p.id); }}
                  title="Copy full property ID (UUID)"
                  style={{ fontSize: '0.75rem', lineHeight: 1, padding: '3px 6px', borderRadius: 4, border: '1px solid #cbd5e1', background: copiedPropId === String(p.id) ? '#dcfce7' : '#fff', color: copiedPropId === String(p.id) ? '#166534' : '#334155', cursor: 'pointer', fontWeight: 600 }}>
                  {copiedPropId === String(p.id) ? '✓' : '📋'}
                </button>
              </div>
              {!inactive && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 2 }}>
                  <span style={{ fontSize: '0.75rem', color: 'var(--theme-primary-dark)', fontWeight: 600, visibility: isSelected ? 'visible' : 'hidden' }}>✓ Selected</span>
                  <button type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      // Outlets only ever re-fetch when selectedPropertyId
                      // actually changes (see the effect keyed on it above).
                      // Clearing selectedKotOutletId/kotOutlets unconditionally
                      // here wiped an outlet the card had already loaded
                      // (clicking the card body first sets it) with nothing
                      // left to restore it, since the id didn't change and
                      // navigation to module-home happens immediately after.
                      if (String(selectedPropertyId) !== String(p.id)) {
                        setSelectedPropertyId(String(p.id));
                        localStorage.setItem('selectedPropertyId', String(p.id));
                        setSelectedKotOutletId('');
                        setKotOutlets([]);
                      }
                      setModuleAccessError('');
                      enterHotelWorkspace();
                    }}
                    title={`Enter ${p.name}`}
                    className="enter-btn"
                    style={{ fontSize: '0.75rem', fontWeight: 700, padding: '4px 10px', borderRadius: 6, border: 'none', background: 'var(--theme-primary-dark)', color: '#fff', cursor: 'pointer' }}>
                    Enter →
                  </button>
                </div>
              )}
            </div>
          );
        };

        return (
          <div className="page-shell">
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.78rem', marginBottom: '0.6rem' }}>
              <span style={{ color: '#6b7280', fontWeight: 500 }}>Hotel Config</span>
              <span style={{ color: '#cbd5e0' }}>›</span>
              <span style={{ color: 'var(--theme-primary-dark)', fontWeight: 600 }}>Select Property</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '0.75rem' }}>
              <h2 style={{ color: 'var(--theme-primary-dark)', margin: 0 }}>Select Hotel Property</h2>
              {accessibleProperties.length > 0 && (
                <div style={{ width: 'min(340px, 100%)' }}>
                  <div style={{ position: 'relative' }}>
                    <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', fontSize: '1rem', color: '#9ca3af', pointerEvents: 'none' }}>🔍</span>
                    <input
                      type="text"
                      value={propertySearchQuery}
                      onChange={(e) => setPropertySearchQuery(e.target.value)}
                      placeholder="Search hotels by name or code…"
                      style={{
                        width: '100%', padding: '0.6rem 2.3rem', borderRadius: 10,
                        border: '1px solid var(--theme-border)', fontSize: '0.88rem',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)', outline: 'none',
                        transition: 'border-color 0.15s, box-shadow 0.15s', boxSizing: 'border-box'
                      }}
                      onFocus={(e) => { e.target.style.borderColor = 'var(--theme-primary-dark)'; e.target.style.boxShadow = '0 0 0 3px #c7d2fe'; }}
                      onBlur={(e) => { e.target.style.borderColor = 'var(--theme-border)'; e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)'; }}
                    />
                    {propertySearchQuery && (
                      <button type="button" onClick={() => setPropertySearchQuery('')}
                        title="Clear search"
                        style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', width: 22, height: 22, borderRadius: '50%', border: 'none', background: '#e5e7eb', color: '#4b5563', cursor: 'pointer', fontSize: '0.8rem', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        ×
                      </button>
                    )}
                  </div>
                  {searchQuery && (
                    <div style={{ marginTop: 5, fontSize: '0.75rem', color: '#9ca3af', textAlign: 'right' }}>
                      {totalMatches} of {accessibleProperties.length + allPropertiesRaw.filter((p) => p.is_active === false).length} properties
                    </div>
                  )}
                </div>
              )}
            </div>
            <p style={{ color: '#6b7280', marginTop: '0.25rem', marginBottom: '1.3rem', fontSize: '0.9rem' }}>Choose the property you want to work with today</p>

            {accessibleProperties.length === 0 ? (
              <div className="info-banner">
                No property assigned. Contact your administrator to assign property access to your account.
              </div>
            ) : searchQuery && totalMatches === 0 ? (
              <div className="info-banner">
                No properties match “{propertySearchQuery.trim()}”. <button type="button" onClick={() => setPropertySearchQuery('')} style={{ marginLeft: 6, border: 'none', background: 'none', color: 'var(--theme-primary-dark)', fontWeight: 600, cursor: 'pointer', textDecoration: 'underline', padding: 0 }}>Clear search</button>
              </div>
            ) : showChainGroups ? (
              chainGroups.map((group) => (
                <div key={group.key} style={{ marginBottom: '1.4rem' }}>
                  <div style={groupLabelStyle}>{group.label} <span style={{ fontWeight: 500, color: '#9ca3af' }}>({group.items.length})</span></div>
                  <div style={gridStyle}>{group.items.map((p) => renderCard(p))}</div>
                </div>
              ))
            ) : (
              <div style={{ ...gridStyle, marginBottom: '1.5rem' }}>
                {searchedActive.map((p) => renderCard(p))}
              </div>
            )}

            {inactiveProps.length > 0 && (
              <div style={{ marginBottom: '1.5rem' }}>
                <div style={{ ...groupLabelStyle, color: '#9ca3af' }}>Inactive <span style={{ fontWeight: 500 }}>({inactiveProps.length})</span></div>
                <div style={gridStyle}>{inactiveProps.map((p) => renderCard(p, { inactive: true }))}</div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
              <button onClick={enterHotelWorkspace} disabled={!selectedPropertyId} className="btn-primary" style={{ padding: '0.65rem 1.8rem', opacity: selectedPropertyId ? 1 : 0.5 }}>
                {role === 'admin' ? 'Enter Hotel Workspace →' : 'Continue →'}
              </button>
              <button onClick={loadAccessibleProperties} className="btn-muted" style={{ padding: '0.65rem 1.2rem' }}>
                Refresh
              </button>
            </div>
          </div>
        );
      })()}

      {screen === 'module-home' && (
        <div style={{ padding: isMobile ? '1rem' : '2rem 2.5rem', maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', gap: '0.7rem', flexWrap: 'wrap', marginBottom: '1.5rem', flexDirection: isMobile ? 'column' : 'row' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
              <h3 style={{ margin: 0, color: 'var(--theme-primary-dark)', fontSize: isMobile ? '0.95rem' : undefined }}>Hotel Workspace</h3>
              {selectedProperty && <span className="tag tag-primary" style={{ fontSize: '0.75rem' }}>{selectedProperty.code} &mdash; {selectedProperty.name}</span>}
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(280px, 1fr))', gap: isMobile ? '0.75rem' : '1.25rem' }}>
            {[
              { label: 'Front Office', iconId: 'front-office', desc: 'Reservations, Check-in/out, Room Rack', gradient: 'linear-gradient(135deg, #3b82f6, #06b6d4)', accent: '#06b6d4', onClick: openFrontOffice, enabled: hasFrontOfficeAccess },
              { label: 'Bar Management', iconId: 'bar-management', desc: 'Orders, Inventory, Billing', gradient: 'linear-gradient(135deg, #f97316, #f59e0b)', accent: '#f97316', onClick: openBarManagement, enabled: hasBarAccess },
              { label: 'KOT & POS', iconId: 'kot', desc: 'Kitchen Orders, Billing', gradient: 'linear-gradient(135deg, #10b981, #14b8a6)', accent: '#10b981', onClick: openKot, enabled: hasKotAccess },
              { label: 'Food Inventory', iconId: 'food-inventory', desc: 'GRN, Purchase, Stock', gradient: 'linear-gradient(135deg, #06b6d4, #22d3ee)', accent: '#06b6d4', onClick: openFoodInventory, enabled: hasFoodInventoryAccess },
              { label: 'Banquet', iconId: 'banquet', desc: 'Bookings, Quotations, Calendar', gradient: 'linear-gradient(135deg, #a855f7, #c084fc)', accent: '#a855f7', onClick: openBanquet, enabled: hasBanquetAccess },
              ...(isHousekeepingModuleEnabledForProperty ? [{ label: 'Housekeeping', iconId: 'housekeeping', desc: 'Room Cleaning Operations', gradient: 'linear-gradient(135deg, #3b82f6, #8b5cf6)', accent: '#3b82f6', onClick: openHousekeeping, enabled: hasHousekeepingAccess }] : []),
              { label: 'Engineering', iconId: 'engineering', desc: 'Work Orders, Maintenance, Assets', gradient: 'linear-gradient(135deg, #6366f1, #8b5cf6)', accent: '#6366f1', onClick: openEngineering, enabled: hasMaintenanceAccess },
              { label: 'Stores', iconId: 'stores', desc: 'Stock, Items, Issues for F&B, HK, Maintenance', gradient: 'linear-gradient(135deg, #0f766e, #14b8a6)', accent: '#0f766e', onClick: openStores, enabled: hasStoresAccess },
              { label: 'Accounting', iconId: 'accounting', desc: 'Tally Export, Live Push, GST', gradient: 'linear-gradient(135deg, #f59e0b, #ef4444)', accent: '#f59e0b', onClick: openAccounting, enabled: hasAccountingAccess },
            ].filter((mod) => mod.enabled && selectedPropertyId).map((mod) => {
              return (
                <button key={mod.label} onClick={mod.onClick}
                  style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '0.75rem', padding: '1.5rem', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '16px', cursor: 'pointer', transition: 'all 0.25s', textAlign: 'left', boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.03)', position: 'relative', overflow: 'hidden' }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 28px rgba(0,0,0,0.1)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.03)'; }}>
                  <div style={{ width: '52px', height: '52px', borderRadius: '14px', background: mod.gradient, display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                    <ModuleIcon id={mod.iconId} size={26} strokeWidth={1.6} color="#fff" />
                  </div>
                  <div style={{ fontWeight: 700, fontSize: '1rem', color: '#1e293b', letterSpacing: '-0.01em' }}>{mod.label}</div>
                  <div style={{ fontSize: '0.82rem', color: '#94a3b8', lineHeight: 1.4, fontWeight: 400 }}>{mod.desc}</div>
                  <div style={{ position: 'absolute', bottom: 0, left: '1rem', right: '1rem', height: '3px', borderRadius: '3px 3px 0 0', background: mod.gradient }} />
                </button>
              );
            })}
          </div>
        </div>
      )}


      {screen === 'dashboard' && hasPermission('dashboard') && <Dashboard stats={stats} />}
      {screen === 'inventory' && hasBarAccess && <Inventory token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'orders' && hasBarAccess && <Orders token={token} onOrdersUpdated={fetchDashboardStats} selectedOutlet={kotOutlets.find(o => String(o.id) === String(selectedKotOutletId)) || null} initialOrderId={pendingBarOrderId} onInitialOrderConsumed={() => setPendingBarOrderId(null)} />}
      {screen === 'station-display' && hasBarAccess && <BarStationDisplay token={token} selectedProperty={selectedProperty} />}
      {screen === 'users' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <Users token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'role-templates' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <RoleTemplateMaster token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'admin-audit-trails' && role === 'admin' && <AdminAuditTrails token={token} />}
      {screen === 'user-login-activity' && role === 'admin' && <PmsUserLoginActivity token={token} />}
      {screen === 'admin-error-log' && role === 'admin' && <AdminErrorLog token={token} />}
      {screen === 'table-master' && hasMastersAccess && <TableMaster token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'store-master' && hasMastersAccess && <StoreMaster token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'uom-master' && hasMastersAccess && <UomMaster token={token} />}
      {screen === 'liquor-category' && hasMastersAccess && <LiquorCategory token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'gst-master' && hasMastersAccess && <GstMaster token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'room-tax-policy-master' && hasMastersAccess && <RoomTaxPolicyMaster token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'pms-policy-config' && <PmsPolicyConfig token={token} selectedProperty={selectedProperty} />}
      {screen === 'general-settings' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <GeneralSettings token={token} selectedProperty={selectedProperty} />}
      {screen === 'compliance-policy' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <PmsCompliancePolicy token={token} selectedProperty={selectedProperty} />}
      {screen === 'guest-portal-settings' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <PmsGuestPortalConfig token={token} selectedProperty={selectedProperty} />}
      {screen === 'pre-checkin-config' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <PmsPreCheckinConfig token={token} selectedProperty={selectedProperty} />}
      {screen === 'alert-settings' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <PmsAlertSettings token={token} selectedProperty={selectedProperty} />}
      {screen === 'guest-login-audit' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <PmsGuestLoginAudit token={token} selectedProperty={selectedProperty} />}
      {screen === 'hotel-ai-features' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <PmsHotelAiFeatures token={token} selectedProperty={selectedProperty} />}
      {screen === 'theme-settings' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <PmsThemeSettings token={token} selectedProperty={selectedProperty} onThemeApplied={(cfg) => {
        setAccessibleProperties(prev => prev.map(p => String(p.id) === String(selectedPropertyId) ? { ...p, theme_config: cfg } : p));
      }} />}
      {screen === 'pms-guest-feedback' && hasFrontOfficeAccess && <PmsGuestFeedback token={token} selectedProperty={selectedProperty} aiEnabled={isAiGuestSentimentActive} />}
      {screen === 'pms-google-review' && hasFrontOfficeAccess && <GoogleReview token={token} selectedProperty={selectedProperty} />}
      {screen === 'ai-features' && role === 'admin' && <PmsAiFeatureConfig token={token} selectedProperty={selectedProperty} />}
      {screen === 'nlp-config' && role === 'admin' && <PmsNlpConfig token={token} />}
      {screen === 'pms-revenue-manager' && hasAiFunctionsAccess && isAiRevenueManagerActive && <PmsRevenueManager token={token} selectedProperty={selectedProperty} />}
      {screen === 'rate-shopper' && hasAiFunctionsAccess && isRateShopperActive && <RateShopper token={token} selectedProperty={selectedProperty} onSwitchScreen={setScreen} onOpenInRms={(ctx) => { setRmsFocus(ctx); setScreen('revenue-manager-rms'); }} focus={rateShopperFocus} onClearFocus={() => setRateShopperFocus(null)} />}
      {screen === 'rate-shopper-mapping' && hasAiFunctionsAccess && isRateShopperActive && <RateShopperMapping token={token} selectedProperty={selectedProperty} onSwitchScreen={setScreen} />}
      {screen === 'price-intelligence' && hasAiFunctionsAccess && isPriceIntelligenceActive && <PriceIntelligence token={token} selectedProperty={selectedProperty} onOpenInRms={(ctx) => { setRmsFocus(ctx); setScreen('revenue-manager-rms'); }} onOpenInRateShopper={(ctx) => { setRateShopperFocus(ctx); setScreen('rate-shopper'); }} />}
      {screen === 'pickup-pace' && hasAiFunctionsAccess && isPriceIntelligenceActive && <PickupPace token={token} selectedProperty={selectedProperty} />}
      {screen === 'rate-shopper-reports' && hasAiFunctionsAccess && isRateShopperActive && <RateShopperReports token={token} selectedProperty={selectedProperty} />}
      {screen === 'revenue-manager-rms' && hasAiFunctionsAccess && isRevenueManagerRmsActive && <RevenueManagerRms token={token} selectedProperty={selectedProperty} onSwitchScreen={setScreen} focus={rmsFocus} onClearFocus={() => setRmsFocus(null)} />}
      {screen === 'pms-noshow-predictor' && hasAiFunctionsAccess && isAiNoShowPredictorActive && <PmsNoShowPredictor token={token} selectedProperty={selectedProperty} />}
      {screen === 'pms-guest-recognition' && hasAiFunctionsAccess && isAiGuestRecognitionActive && <PmsGuestRecognition token={token} selectedProperty={selectedProperty} />}
      {screen === 'pms-occupancy-forecast' && hasAiFunctionsAccess && isAiOccupancyForecastActive && <PmsOccupancyForecast token={token} selectedProperty={selectedProperty} />}
      {screen === 'pms-upsell-engine' && hasAiFunctionsAccess && isAiUpsellEngineActive && <PmsUpsellEngine token={token} selectedProperty={selectedProperty} />}
      {screen === 'pms-staff-assistant' && hasAiFunctionsAccess && isAiStaffAssistantActive && <PmsStaffAssistant token={token} selectedProperty={selectedProperty} />}
      {screen === 'pms-folio-anomaly' && hasAiFunctionsAccess && isAiFolioAnomalyActive && <PmsFolioAnomaly token={token} selectedProperty={selectedProperty} />}
      {screen === 'pms-night-audit-anomaly' && hasAiFunctionsAccess && isAiNightAuditAnomalyActive && <PmsNightAuditAnomaly token={token} selectedProperty={selectedProperty} />}
      {screen === 'pms-corporate-risk' && hasAiFunctionsAccess && isAiCorporateCreditRiskActive && <PmsCorporateCreditRisk token={token} selectedProperty={selectedProperty} />}
      {screen === 'item-master' && hasMastersAccess && <ItemMaster token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'menu-setup' && hasMastersAccess && <MenuSetup token={token} />}
      {screen === 'bar-billing-info' && hasMastersAccess && <BarBillingInfo token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'bar-masters' && hasMastersAccess && <BarMastersHub token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'bar-reports' && hasBarAccess && <BarReports token={token} selectedPropertyId={selectedPropertyId} />}
      {screen === 'chain-master' && role === 'admin' && (
        <ChainMaster
          token={token}
          onManageProperties={() => {
            setActiveMenu('hotel-config');
            setScreen('property-master');
          }}
        />
      )}
      {screen === 'property-master' && role === 'admin' && <PropertyMaster token={token} />}
      {screen === 'country-master' && role === 'admin' && <CountryMaster token={token} />}
      {screen === 'currency-master' && role === 'admin' && <CurrencyMaster token={token} />}
      {screen === 'timezone-master' && role === 'admin' && <TimezoneMaster token={token} />}
      {screen === 'go-live-purge' && role === 'admin' && <PmsGoLivePurge token={token} selectedProperty={selectedProperty} />}
      {screen === 'channel-manager-settings' && role === 'admin' && <ChannelManagerSettings token={token} />}
      {screen === 'competitor-rate-settings' && role === 'admin' && <CompetitorRateSettings token={token} selectedProperty={selectedProperty} />}
      {screen === 'rate-shopper-log' && role === 'admin' && <RateShopperLog token={token} selectedProperty={selectedProperty} />}
      {screen === 'training-material' && role === 'admin' && <TrainingMaterial />}
      {screen === 'lock-system' && (role === 'admin' || Boolean(permissions?.lock_admin)) && <PmsLockVendorConfig token={token} selectedProperty={selectedProperty} onNavigateToAgents={() => setScreen('lock-agents')} />}
      {screen === 'lock-agents' && (role === 'admin' || Boolean(permissions?.lock_admin)) && <PmsLockAgents token={token} selectedProperty={selectedProperty} />}
      {screen === 'lock-authorizations' && (role === 'admin' || Boolean(permissions?.lock_admin)) && <PmsLockAuthorizations token={token} selectedProperty={selectedProperty} />}
      {screen === 'pms-door-audit' && (role === 'admin' || Boolean(permissions?.door_audit) || Boolean(permissions?.front_office)) && <PmsDoorAudit token={token} selectedProperty={selectedProperty} />}
      {(screen === 'sms-providers-settings' || screen === 'email-settings') && (role === 'admin' || role === 'hotel_admin' || permissions?.hotel_admin) && <SmsProviderSettings token={token} selectedProperty={selectedProperty} role={role} />}
      {screen === 'sms-templates-events' && role === 'admin' && <SmsTemplatesEvents token={token} />}
      {screen === 'whatsapp-platform-settings' && role === 'admin' && <WhatsAppPlatformSettings token={token} />}
      {screen === 'whatsapp-settings' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <WhatsAppHotelSettings token={token} selectedProperty={selectedProperty} />}
      {screen === 'shorten-url-settings' && role === 'admin' && <ShortenUrlSettings token={token} />}
      {screen === 'ticketing-settings' && role === 'admin' && <TicketingSettings token={token} selectedProperty={selectedProperty} />}
      {screen === 'banquet-intel-config' && role === 'admin' && <BanquetIntelConfig token={token} selectedProperty={selectedProperty} userScopes={userScopes} accessibleProperties={accessibleProperties} />}
      {screen === 'event-api-config' && role === 'admin' && <EventApiConfig token={token} selectedProperty={selectedProperty} userScopes={userScopes} accessibleProperties={accessibleProperties} />}
      {screen === 'event-sync-log' && role === 'admin' && <EventSyncLog token={token} selectedProperty={selectedProperty} />}
      {screen === 'ai-usage-dashboard' && role === 'admin' && <AiUsageDashboard token={token} selectedProperty={selectedProperty} />}

      {/* Subscription Admin Screens */}
      {screen === 'sub-dashboard' && role === 'admin' && <SubscriptionDashboard token={token} />}
      {screen === 'sub-modules' && role === 'admin' && <SubscriptionModuleCatalog token={token} />}
      {screen === 'sub-plans' && role === 'admin' && <SubscriptionPlanManager token={token} />}
      {screen === 'sub-all' && role === 'admin' && <SubscriptionList token={token} onViewDetail={(id) => { setScreen('sub-detail'); window.__subDetailId = id; }} />}
      {screen === 'sub-detail' && role === 'admin' && <SubscriptionDetail token={token} subscriptionId={window.__subDetailId} onBack={() => setScreen('sub-all')} />}
      {screen === 'sub-pricing' && role === 'admin' && <SubscriptionPriceOverrides token={token} />}
      {screen === 'sub-config' && role === 'admin' && <SubscriptionConfig token={token} />}

      {/* Subscription Tenant Screens */}
      {screen === 'my-subscription' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <MySubscription token={token} selectedProperty={selectedProperty} role={role} permissions={permissions} />}
      {screen === 'my-subscription-invoices' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <MySubscriptionInvoices token={token} selectedProperty={selectedProperty} />}
      {screen === 'kot-dashboard' && hasKotAccess && (
        <KotDashboard token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />
      )}
      {screen === 'kot' && hasKotAccess && <KOTModule token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} selectedOutlet={kotOutlets.find(o => String(o.id) === String(selectedKotOutletId)) || null} initialBillId={pendingKotBillId} onInitialBillConsumed={() => setPendingKotBillId(null)} />}
      {screen === 'kot-kitchen-punch' && hasKotAccess && <KitchenPunchBoard token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-bill-reports' && hasKotAccess && <KotBillReports token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} allowedOutletIds={kotOutlets.map((o) => String(o.id))} canCorrectPaymentMode={role === 'admin' || String(role || '').toLowerCase() === 'hotel_admin' || Boolean(permissions?.hotel_admin)} />}
      {screen === 'kot-masters' && hasKotAccess && <KotMastersHub token={token} selectedProperty={selectedProperty} onOutletChanged={loadKotOutlets} />}
      {screen === 'kot-outlet-master' && hasKotAccess && <KotOutletMaster token={token} selectedProperty={selectedProperty} onOutletChanged={loadKotOutlets} />}
      {screen === 'kot-station-master' && hasKotAccess && <KotKitchenStationMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-table-master' && hasKotAccess && <KotTableMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-food-type' && hasKotAccess && <KotFoodTypeMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-food-category' && hasKotAccess && <KotFoodCategoryMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-item-master' && hasKotAccess && <KotItemMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-time-slot' && hasKotAccess && <KotTimeSlotMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-tax-profile' && hasKotAccess && <KotTaxProfileMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-pricing-profile' && hasKotAccess && <KotPricingProfileMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-menu-type' && hasKotAccess && <KotMenuTypeMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'kot-menu-category' && hasKotAccess && <KotMenuCategoryMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />}
      {screen === 'food-general-settings' && canAccessFoodScreen('food-general-settings') && <FoodGeneralSettings token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-store-master' && canAccessFoodScreen('food-store-master') && <FoodStoreMaster token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-pr' && canAccessFoodScreen('food-pr') && <FoodPurchaseRequisition token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-po' && canAccessFoodScreen('food-po') && <FoodPurchaseOrder token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-grn' && canAccessFoodScreen('food-grn') && <FoodGrn token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-stock-view' && canAccessFoodScreen('food-stock-view') && <FoodStockView token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-store-issue' && canAccessFoodScreen('food-store-issue') && <FoodStoreIssue token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-stock-transfer' && canAccessFoodScreen('food-stock-transfer') && <FoodStockTransfer token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-stock-adjustment' && canAccessFoodScreen('food-stock-adjustment') && <FoodStockAdjustment token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-physical-count' && canAccessFoodScreen('food-physical-count') && <FoodPhysicalCount token={token} selectedProperty={selectedProperty} />}
      {screen === 'food-item-master' && canAccessFoodScreen('food-item-master') && <FoodItemMaster token={token} selectedPropertyId={selectedPropertyId} selectedProperty={selectedProperty} />}
      {screen === 'food-supplier-master' && canAccessFoodScreen('food-supplier-master') && <FoodSupplierMaster token={token} selectedPropertyId={selectedPropertyId} selectedProperty={selectedProperty} />}
      {screen === 'food-reports' && canAccessFoodScreen('food-reports') && <FoodReports token={token} selectedProperty={selectedProperty} />}
      {screen === 'banquet-masters' && hasBanquetCoreAccess && (
        <div className="banquet-kot-theme">
          <BanquetMastersHub
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedKotOutletId}
            showHelp={role === 'admin' || Boolean(permissions?.hotel_admin)}
            onOpenFaq={() => {
              setActiveMenu('hotel-config');
              setScreen('faq-assistant');
            }}
          />
        </div>
      )}
      {screen === 'banquet-menu-master' && hasBanquetCoreAccess && (
        <div className="banquet-kot-theme">
          <BanquetMenuMaster token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId} />
        </div>
      )}
      {screen === 'banquet-quotations-v2' && hasBanquetCoreAccess && (
        <div className="banquet-kot-theme">
          <BanquetQuotationV2 token={token} selectedProperty={selectedProperty} selectedOutletId={selectedKotOutletId}
            leadPrefill={banquetLeadPrefill} onLeadPrefillConsumed={() => setBanquetLeadPrefill(null)} />
        </div>
      )}
      {screen === 'banquet-quotations' && hasBanquetCoreAccess && (
        <div className="banquet-kot-theme">
          <BanquetQuotation
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedKotOutletId}
            showHelp={role === 'admin' || Boolean(permissions?.hotel_admin)}
            leadPrefill={banquetLeadPrefill}
            onLeadPrefillConsumed={() => setBanquetLeadPrefill(null)}
            onOpenFaq={() => {
              setActiveMenu('hotel-config');
              setScreen('faq-assistant');
            }}
          />
        </div>
      )}
      {screen === 'banquet-bookings' && hasBanquetCoreAccess && (
        <div className="banquet-kot-theme">
          <BanquetBooking
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedKotOutletId}
            showHelp={role === 'admin' || Boolean(permissions?.hotel_admin)}
            onOpenFaq={() => {
              setActiveMenu('hotel-config');
              setScreen('faq-assistant');
            }}
          />
        </div>
      )}
      {screen === 'banquet-payments' && hasBanquetCoreAccess && (
        <div className="banquet-kot-theme">
          <BanquetPayments
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedKotOutletId}
            showHelp={role === 'admin' || Boolean(permissions?.hotel_admin)}
            onOpenFaq={() => {
              setActiveMenu('hotel-config');
              setScreen('faq-assistant');
            }}
          />
        </div>
      )}
      {screen === 'banquet-calendar' && hasBanquetCoreAccess && (
        <div className="banquet-kot-theme">
          <BanquetCalendar
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedKotOutletId}
            showHelp={role === 'admin' || Boolean(permissions?.hotel_admin)}
            onOpenFaq={() => {
              setActiveMenu('hotel-config');
              setScreen('faq-assistant');
            }}
          />
        </div>
      )}
      {screen === 'banquet-reports' && hasBanquetCoreAccess && (
        <div className="banquet-kot-theme">
          <BanquetReports
            token={token}
            selectedProperty={selectedProperty}
            selectedOutletId={selectedKotOutletId}
            showHelp={role === 'admin' || Boolean(permissions?.hotel_admin)}
            onOpenFaq={() => {
              setActiveMenu('hotel-config');
              setScreen('faq-assistant');
            }}
          />
        </div>
      )}
      {screen === 'banquet-intelligence' && hasBanquetCoreAccess && (
        <BanquetCompetitorMaster token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'banquet-demand-forecast' && hasBanquetCoreAccess && (
        <BanquetDemandForecast token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'banquet-pricing-advisor' && hasBanquetCoreAccess && (
        <BanquetPricingAdvisor token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'banquet-variance-report' && hasBanquetCoreAccess && (
        <BanquetVarianceReport token={token} selectedProperty={selectedProperty} onNavigate={(key) => setScreen(key)} />
      )}
      {screen === 'banquet-crm-dashboard' && hasBanquetCrmAccess && (
        <BanquetCrmDashboard token={token} selectedProperty={selectedProperty} onNavigate={(key) => setScreen(key)} />
      )}
      {screen === 'banquet-leads' && hasBanquetCrmAccess && (
        <BanquetLeads token={token} selectedProperty={selectedProperty}
          onNavigateToDetail={(id) => { setBanquetCrmLeadId(id); setScreen('banquet-lead-detail'); }}
          onNavigateToConflicts={(clusterKey) => { setBanquetFocusClusterKey(clusterKey || null); setScreen('banquet-lead-conflicts'); }} />
      )}
      {screen === 'banquet-lead-conflicts' && hasBanquetCrmAccess && (
        <PmsBanquetLeadConflicts token={token} selectedProperty={selectedProperty}
          focusClusterKey={banquetFocusClusterKey}
          onClearFocus={() => setBanquetFocusClusterKey(null)} />
      )}
      {screen === 'banquet-lead-detail' && hasBanquetCrmAccess && banquetCrmLeadId && (
        <BanquetLeadDetail token={token} selectedProperty={selectedProperty} leadId={banquetCrmLeadId}
          onBack={() => { setBanquetCrmLeadId(null); setScreen('banquet-leads'); }}
          onNavigateToConfig={() => setScreen('banquet-crm-config')}
          onNavigateToQuotation={(prefill) => { setBanquetLeadPrefill(prefill); setActiveMenu('banquet'); setScreen('banquet-quotations-v2'); }} />
      )}
      {screen === 'banquet-pipeline' && hasBanquetCrmAccess && (
        <BanquetPipeline token={token} selectedProperty={selectedProperty}
          onNavigateToDetail={(id) => { setBanquetCrmLeadId(id); setScreen('banquet-lead-detail'); }} />
      )}
      {screen === 'banquet-follow-ups' && hasBanquetCrmAccess && (
        <BanquetFollowUps token={token} selectedProperty={selectedProperty}
          onNavigateToLead={(id) => { setBanquetCrmLeadId(id); setScreen('banquet-lead-detail'); }} />
      )}
      {screen === 'banquet-crm-config' && hasBanquetCrmAccess && (
        <BanquetCrmConfig token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'pms-dashboard' && hasFrontOfficeAccess && (
        <PmsDashboard token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'pms-reports' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsReports token={token} selectedPropertyId={selectedPropertyId} selectedProperty={selectedProperty} />
        </div>
      )}
      {screen === 'pms-command-center' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsCommandCenter token={token} selectedProperty={selectedProperty} role={role} permissions={permissions} onOpenWalkIn={openWalkInFromRack} onEditReservation={openEditReservationFromRack} onNewReservation={openNewReservation} onNewWalkIn={openNewWalkIn} onOpenExceptionBill={openExceptionBill} />
        </div>
      )}
      {screen === 'pms-front-desk-board' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsFrontDeskBoard token={token} selectedProperty={selectedProperty} onOpenWalkIn={openWalkInFromRack} onEditReservation={openEditReservationFromRack} onNewReservation={openNewReservation} onNewWalkIn={openNewWalkIn} />
        </div>
      )}
      {screen === 'pms-rate-matrix' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsRateMatrix
            token={token}
            selectedProperty={selectedProperty}
            onOpenUpdateRate={() => setScreen('pms-rate-matrix-update')}
          />
        </div>
      )}
      {screen === 'pms-rate-matrix-update' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsRateMatrixUpdate
            token={token}
            selectedProperty={selectedProperty}
            onBackToView={() => setScreen('pms-rate-matrix')}
          />
        </div>
      )}
      {screen === 'pms-masters' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsMastersHub token={token} selectedProperty={selectedProperty} />
        </div>
      )}
      {screen === 'pms-upsell-products' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsUpsellProducts token={token} selectedProperty={selectedProperty} />
        </div>
      )}
      {screen === 'pms-upsell-leaderboard' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsUpsellLeaderboard token={token} selectedProperty={selectedProperty} />
        </div>
      )}
      {screen === 'pms-guest-master' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsGuestMaster token={token} selectedProperty={selectedProperty} onReCheckIn={reCheckInGuest} onMakeReservation={makeReservationForGuest} />
        </div>
      )}
      {screen === 'pms-reservations' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsReservation token={token} role={role} permissions={permissions} foMenuAccess={isFoMenuUnrestricted ? null : permissions.fo_menu_access} selectedProperty={selectedProperty} initialEditId={openEditReservationId} onInitialEditConsumed={() => setOpenEditReservationId(null)} prefillGuest={prefillGuestForReservation} onPrefillGuestConsumed={() => setPrefillGuestForReservation(null)} aiGuestRecognitionEnabled={isAiGuestRecognitionActive} />
        </div>
      )}
      {screen === 'pms-walkin' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsWalkInCheckIn token={token} role={role} selectedProperty={selectedProperty} prefilledRoom={pmsWalkInPrefill} prefillGuest={prefillGuestForWalkIn} onPrefillGuestConsumed={() => setPrefillGuestForWalkIn(null)} aiGuestRecognitionEnabled={isAiGuestRecognitionActive} />
        </div>
      )}
      {screen === 'pms-police-report' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsPoliceReport token={token} selectedProperty={selectedProperty} />
        </div>
      )}
      {screen === 'pms-invoice-register' && hasFrontOfficeAccess && (
        <PmsInvoiceRegister token={token} selectedPropertyId={selectedPropertyId} selectedProperty={selectedProperty} permissions={permissions} role={role} />
      )}
      {screen === 'pms-rate-quotation' && hasFrontOfficeAccess && (
        <PmsRateQuotation token={token} selectedPropertyId={selectedPropertyId} selectedProperty={selectedProperty} permissions={permissions} role={role} />
      )}
      {screen === 'pms-folio-void-audit' && (role === 'admin' || role === 'hotel_admin' || Boolean(permissions?.hotel_admin)) && (
        <PmsFolioVoidAudit token={token} selectedPropertyId={selectedPropertyId} selectedProperty={selectedProperty} permissions={permissions} role={role} />
      )}
      {screen === 'pms-invoice-amend-audit' && (role === 'admin' || Boolean(permissions?.invoice_amend) || Boolean(permissions?.hotel_admin)) && (
        <PmsInvoiceAmendmentAudit token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'pms-agent-payments' && hasFrontOfficeAccess && (
        <PmsAgentPayments token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'pms-easeroom-cm' && hasFrontOfficeAccess && (
        <div>
          <div style={{ display: 'flex', gap: 0, borderBottom: '2px solid var(--theme-border)', margin: '0 1rem' }}>
            {[
              { key: 'mapping', label: 'CM Mapping' },
              { key: 'reservation-log', label: 'OTA Booking Log' },
              { key: 'push-log', label: 'CM Push Log' },
              { key: 'rate-push-log', label: 'CM Rate Push Log' },
              { key: 'booking-push-log', label: 'CM Booking Push Log' },
            ].map((t) => (
              <button key={t.key} onClick={() => setCmTab(t.key)}
                style={{
                  padding: '0.55rem 1.1rem', fontSize: '0.82rem', fontWeight: cmTab === t.key ? 700 : 500,
                  color: cmTab === t.key ? '#1e40af' : '#6b7280',
                  background: cmTab === t.key ? '#eff6ff' : 'transparent',
                  border: 'none', borderBottom: cmTab === t.key ? '2px solid #2563eb' : '2px solid transparent',
                  marginBottom: '-2px', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.15s'
                }}>
                {t.label}
              </button>
            ))}
          </div>
          {cmTab === 'mapping' && <PmsCmMapping token={token} selectedProperty={selectedProperty} />}
          {cmTab === 'reservation-log' && <PmsCmBookingLog token={token} selectedProperty={selectedProperty} />}
          {cmTab === 'push-log' && <PmsCmPushLog token={token} selectedProperty={selectedProperty} />}
          {cmTab === 'rate-push-log' && <PmsCmRatePushLog token={token} selectedProperty={selectedProperty} />}
          {cmTab === 'booking-push-log' && <PmsCmBookingPushLog token={token} selectedProperty={selectedProperty} />}
        </div>
      )}
      {screen === 'pms-room-inventory' && hasFrontOfficeAccess && (
        <PmsRoomInventory token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'pms-group-booking' && hasFrontOfficeAccess && (
        <PmsGroupBooking token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'pms-night-audit' && hasFrontOfficeAccess && (
        <PmsNightAudit token={token} selectedProperty={selectedProperty} role={role} permissions={permissions} />
      )}
      {screen === 'pms-housekeeping' && hasHousekeepingAccess && (
        <div className="banquet-kot-theme">
          <PmsHousekeeping token={token} selectedProperty={selectedProperty} aiOptimizerEnabled={isAiHousekeepingOptimizerActive} />
        </div>
      )}
      {screen === 'hk-amenity-stock' && hasHousekeepingAccess && (
        <HkAmenityStock token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'hk-config' && (role === 'admin' || Boolean(permissions?.hotel_admin)) && <HkConfigHub token={token} selectedProperty={selectedProperty} />}
      {screen === 'maint-dashboard' && hasMaintenanceAccess && (
        <MaintDashboard token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'maint-work-orders' && (
        <MaintWorkOrders token={token} selectedProperty={selectedProperty} role={role} permissions={permissions} />
      )}
      {screen === 'maint-preventive' && hasMaintenanceAccess && (
        <MaintPreventive token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'maint-masters-hub' && hasMaintenanceAccess && (
        <MaintMastersHub token={token} selectedProperty={selectedProperty} />
      )}
      {screen === 'maint-reports' && hasMaintenanceAccess && (
        <MaintReports token={token} selectedProperty={selectedProperty} />
      )}
      {String(screen || '').startsWith('stores-') && hasStoresAccess && (
        <StoresModule token={token} selectedProperty={selectedProperty} view={screen} />
      )}
      {screen === 'pms-guest-requests' && hasFrontOfficeAccess && (
        <div className="banquet-kot-theme">
          <PmsGuestRequests token={token} selectedProperty={selectedProperty} />
        </div>
      )}
      {screen === 'pms-gm-reports' && hasFrontOfficeAccess && (
        <PmsGmReports token={token} selectedPropertyId={selectedPropertyId} selectedProperty={selectedProperty} />
      )}
      {screen === 'gst-reports' && hasAccountingAccess && <GstReports token={token} selectedPropertyId={selectedPropertyId} selectedProperty={selectedProperty} />}
      {screen === 'accounting-reconciliation' && hasAccountingAccess && <AccountingReconciliation token={token} selectedProperty={selectedProperty} />}
      {screen === 'accounting-export' && hasAccountingAccess && <AccountingTallyExport token={token} selectedProperty={selectedProperty} />}
      {screen === 'accounting-export-settings' && hasAccountingAccess && <AccountingExportSettings token={token} selectedProperty={selectedProperty} />}
      {screen === 'tally-push-settings' && <TallyPushSettings token={token} selectedProperty={selectedProperty} />}
      {screen === 'tally-live-push' && hasAccountingAccess && <TallyLivePush token={token} selectedProperty={selectedProperty} />}
      {screen === 'expense-dashboard'     && hasExpenseAccess        && <PmsExpenseDashboard token={token} selectedProperty={selectedProperty} />}
      {screen === 'expense-property-pnl'  && hasExpenseAccess        && <PmsPropertyPnl token={token} selectedProperty={selectedProperty} />}
      {screen === 'expense-entry'         && hasExpenseAccess        && <PmsExpenseEntry token={token} selectedProperty={selectedProperty} />}
      {screen === 'expense-list'          && hasExpenseAccess        && <PmsExpenseList token={token} selectedProperty={selectedProperty} />}
      {screen === 'expense-approval'      && hasExpenseApproveAccess && <PmsExpenseApproval token={token} selectedProperty={selectedProperty} />}
      {screen === 'expense-petty-cash'    && hasPettyCashAccess      && <PmsPettyCash token={token} selectedProperty={selectedProperty} />}
      {screen === 'expense-reports'       && hasExpenseAccess        && <PmsExpenseReports token={token} selectedProperty={selectedProperty} />}
      {screen === 'expense-anomaly'       && hasExpenseAccess        && <PmsExpenseAnomaly token={token} selectedProperty={selectedProperty} />}
      {screen === 'expense-masters'       && hasExpenseAdminAccess   && <PmsExpenseMastersHub token={token} selectedProperty={selectedProperty} permissions={permissions} />}
      {screen === 'revenue-target-dashboard' && hasRevenueDashboardAccess && <PmsRevenueTargetDashboard token={token} selectedProperty={selectedProperty} permissions={permissions} />}
      {screen === 'revenue-reports'          && hasRevenueDashboardAccess && <PmsRevenueReports token={token} selectedProperty={selectedProperty} />}
      {screen === 'faq-assistant' && <FaqAssistant token={token} />}

      {/* ── Floating Widgets (gated by FAB toggle) ── */}
      {token && fabOpen && hasAiFunctionsAccess && isAiStaffAssistantActive && screen !== 'pms-staff-assistant' && (
        <AiFloatingWidget token={token} selectedProperty={selectedProperty} />
      )}
      {token && fabOpen && (
        <AiAssistantWidget token={token} />
      )}
      {token && fabOpen && ticketingEnabled && selectedProperty?.id && (
        <ReportIssueWidget token={token} selectedProperty={selectedProperty} username={username} screenName={(() => { const parts = screen === 'module-home' ? ['Hotel Config', 'Modules'] : breadcrumbParts; return parts.join(' > '); })()}  />
      )}

      {/* ── FAB Toggle Button ── */}
      {token && (
        <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 9995, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
          {fabHover && (
            <div style={{
              padding: '0.3rem 0.7rem', borderRadius: 6, background: '#1f2937', color: '#fff',
              fontSize: '0.75rem', fontWeight: 600, whiteSpace: 'nowrap', boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
              pointerEvents: 'none'
            }}>
              {fabOpen ? 'Close tools' : 'Tools'}
            </div>
          )}
          <button onClick={() => setFabOpen(f => !f)}
            onMouseEnter={() => setFabHover(true)}
            onMouseLeave={() => setFabHover(false)}
            aria-label={fabOpen ? 'Close tools' : 'Open tools'}
            style={{
              width: 48, height: 48, borderRadius: '50%', border: 'none', cursor: 'pointer',
              background: fabOpen ? '#475569' : 'linear-gradient(135deg, #3b82f6, #2563eb)',
              color: '#fff', fontSize: fabOpen ? '1.3rem' : '1.5rem', fontWeight: 700, lineHeight: 1,
              boxShadow: fabOpen ? '0 4px 16px rgba(71,85,105,0.4)' : '0 4px 16px rgba(37,99,235,0.35)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'transform 0.15s, background 0.15s, box-shadow 0.15s',
              transform: fabHover ? 'scale(1.06)' : 'scale(1)'
            }}>
            {fabOpen ? '✕' : '+'}
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
